"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6874],{

/***/ 10569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ CheckButtonStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const CheckButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CheckButtonstyle__CheckButtonStyle",
  componentId: "sc-1v2zgji-0"
})(["display:flex;align-items:baseline;cursor:pointer;", " label{margin-left:10px;flex:1;width:100%;cursor:pointer;user-select:none;}}", " input[type=\"checkbox\"]{", " visibility:hidden;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;}@supports (-moz-appearance:none){input[type=\"checkbox\"]{visibility:visible;position:relative;margin-right:5px;margin-top:unset;cursor:pointer;width:18px;height:18px;accent-color:var(--tm-accent-color);}}input[type='checkbox']::before{width:16px;height:16px;display:flex;visibility:visible;flex-shrink:0;border:1px solid #4a4a4a;border-radius:4px;background:#fff;position:absolute;top:0px;left:-2px;content:'';}input[type='checkbox']::after{content:'';display:block;width:4px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin:0px 0 0 4px;position:absolute;visibility:visible;top:3px;left:0px;", "}input[type='checkbox']:checked::before{", " border:unset;}"], props => props.margin && `margin: ${props.margin};`, props => props.travellingTo && `
 label{
  position:absolute;
  left:8px;
  bottom:8px;
 }
`, props => !props.isDisabled && `cursor: pointer;`, props => props.greyOut && `
             opacity: 0;
        `, props => props.isDisabled ? `background: #0000004D;` : `background: var(--tm-accent-color);`);

/***/ }),

/***/ 97004:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _CheckButton_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10569);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);





const CheckButton = ({
  children,
  inputId,
  travellingTo,
  handleChange,
  inputIndex,
  isDisabled,
  isChecked = false,
  margin,
  greyOut
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_CheckButton_style__WEBPACK_IMPORTED_MODULE_1__/* .CheckButtonStyle */ .m, {
    margin: margin,
    travellingTo: travellingTo,
    isDisabled: isDisabled,
    greyOut: greyOut,
    "data-test-id": "CheckButton-CheckButtonStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
      onChange: handleChange,
      type: "checkbox",
      id: inputId,
      checked: isChecked
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("label", {
      htmlFor: inputId,
      id: inputId,
      "data-test-id": "CheckButton-label",
      children: children
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CheckButton);

/***/ }),

/***/ 59219:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ClaimYourInsurance_ClaimYourInsurance)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/index.ts + 1 modules
var constants = __webpack_require__(36209);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RichText/RichText.tsx
var RichText = __webpack_require__(61643);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.style.ts
var FlexComp_style = __webpack_require__(88025);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.style.ts





const ClaimYourInsuranceStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimYourInsuranceStyle",
  componentId: "uew8se-0"
})(["background:", ";width:100%;padding:100px 0;@media ", "{padding:48px 16px;", "{> ", "{overflow-y:auto;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;-webkit-overflow-scrolling:touch;}}}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `none` : `#f6f6f6`, utils/* deviceType.mobile */.vO.mobile, CommonStyles_style/* InnerContentWrap */.I, FlexComp_style/* FlexCompStyle */.l);
const ClaimStructureStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ClaimYourInsurancestyle__ClaimStructureStyle",
  componentId: "uew8se-1"
})(["background:#ffffff;border-radius:18.9111px;padding:30px 20px;display:flex;flex-direction:column;gap:16px;width:", ";position:relative;flex-shrink:0;> img{flex-shrink:0;position:absolute;right:-34%;top:40%;}@media ", "{padding:16px;width:180px;> img{right:-21%;}}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? "206px" : "226px", utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimStructure.tsx










const ClaimStructure = ({
  claimIndex,
  claimInfo,
  showSpiral
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ClaimStructureStyle, {
    "data-test-id": "ClaimStructure-ClaimStructureStyle",
    children: [context === constants/* PARTNER.MMT */.R.MMT ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H2Tag",
      children: claimIndex
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H3Tag, {
      color: Global/* theme.prussianBlue */.rS.prussianBlue,
      "data-test-id": "ClaimStructure-H3Tag",
      children: claimIndex
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
      "data-test-id": "ClaimStructure-SpanTag",
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* default */.Z, {
        value: claimInfo,
        "data-test-id": "ClaimStructure-RichText"
      })]
    }), !showSpiral && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      width: device == "lg" ? "57px" : "24px",
      height: device == "lg" ? "57px" : "24px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/grey_Spiral_de40650b4c.svg",
      "data-test-id": "ClaimStructure-ImageComponent"
    })]
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimStructure = (ClaimStructure);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.tsx













const ClaimYourInsurance = ({
  data,
  title,
  info
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "claim_your_insurance_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: claimInsuranceRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsuranceStyle, {
    ref: claimInsuranceRef,
    "data-test-id": "ClaimYourInsurance-ClaimYourInsuranceStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "ClaimYourInsurance-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
          color: Global/* theme.greenText */.rS.greenText,
          margin: "0 0 86px",
          "data-test-id": "ClaimYourInsurance-H2Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
          color: Global/* theme.greenText5 */.rS.greenText5,
          margin: "0 0 20px",
          "data-test-id": "ClaimYourInsurance-H5Tag",
          children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: info,
            "data-test-id": "ClaimYourInsurance-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        gap: device == "lg" ? "100px" : "48px",
        "data-test-id": "ClaimYourInsurance-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance_ClaimStructure, {
              claimInfo: item.claimInfo,
              claimIndex: item.claimIndex,
              showSpiral: index == data.length - 1,
              "data-test-id": `ClaimYourInsurance-ClaimStructure-${index}`
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const ClaimYourInsurance_ClaimYourInsurance = (ClaimYourInsurance);

/***/ }),

/***/ 23111:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _BannerCarousel_BannerCarousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73818);
/* harmony import */ var _ExculsiveOffers_ExclusiveOffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13864);
/* harmony import */ var _InsuranceStats_InsuranceStats__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89578);
/* harmony import */ var _LandingFaq_LandingFaq__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73517);
/* harmony import */ var _OffersBenefitsSection_OffersBenefitsSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22637);
/* harmony import */ var _PaymentOfferBreakdown_PaymentOfferBreakdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93252);
/* harmony import */ var _PoweredBySection_PoweredBySection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94879);
/* harmony import */ var _SafenSecureTrav_SafenSecureTrav__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17251);
/* harmony import */ var _TestimonialsSection_TestimonialsSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95595);
/* harmony import */ var _WhatsCovered_WhatsCovered__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2450);
/* harmony import */ var _WhyBuySection_WhyBuySection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53797);
/* harmony import */ var _WhyBuyTravIns_WhyBuyTravIns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62107);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52322);
















const CommonLandingBottomComp = ({
  desktopLayout,
  offers
}) => {
  const {
    faq,
    customNumbers,
    whyBuySection,
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    offersAndBenefits,
    poweredBy,
    marketingBannerSection,
    testimonialSection,
    paymentOfferBreakdown
  } = desktopLayout?.pageInfo || {};
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
    children: [customNumbers && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_InsuranceStats_InsuranceStats__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      data: customNumbers,
      "data-test-id": "CommonLandingBottomComp-InsuranceStats"
    }), paymentOfferBreakdown && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_PaymentOfferBreakdown_PaymentOfferBreakdown__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      data: paymentOfferBreakdown,
      "data-test-id": "CommonLandingBottomComp-PaymentOfferBreakdown"
    }), offers && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ExculsiveOffers_ExclusiveOffers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: offers,
      "data-test-id": "CommonLandingBottomComp-ExclusiveOffers"
    }), whyBuySection && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_WhyBuySection_WhyBuySection__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      whyBuySectionData: whyBuySection,
      "data-test-id": "CommonLandingBottomComp-WhyBuySection"
    }), TravelInsData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_WhyBuyTravIns_WhyBuyTravIns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      title: TravelInsData.title,
      info: TravelInsData.info,
      data: TravelInsData.featureCard,
      "data-test-id": "CommonLandingBottomComp-WhyBuyTravIns"
    }), safeSecureTravel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SafenSecureTrav_SafenSecureTrav__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      data: safeSecureTravel.safeTravCrd,
      title: safeSecureTravel.title,
      "data-test-id": "CommonLandingBottomComp-SafenSecureTrav"
    }), whatsCovered && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_WhatsCovered_WhatsCovered__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      data: whatsCovered.travCrd,
      title: whatsCovered.title,
      info: whatsCovered.info,
      "data-test-id": "CommonLandingBottomComp-WhatsCovered"
    }), offersAndBenefits && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_OffersBenefitsSection_OffersBenefitsSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      data: offersAndBenefits,
      "data-test-id": "CommonLandingBottomComp-OffersBenefitsSection"
    }), poweredBy && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_PoweredBySection_PoweredBySection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      data: poweredBy,
      "data-test-id": "CommonLandingBottomComp-PoweredBySection"
    }), testimonialSection && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_TestimonialsSection_TestimonialsSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      data: testimonialSection,
      "data-test-id": "CommonLandingBottomComp-TestimonialsSection"
    }), marketingBannerSection && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_BannerCarousel_BannerCarousel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      banners: marketingBannerSection,
      autoScrollInterval: 3000,
      "data-test-id": "CommonLandingBottomComp-BannerCarousel"
    }), faq && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_LandingFaq_LandingFaq__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      customTitle: faq?.title,
      faq: faq?.faqList,
      customInfo: faq?.info,
      icon: faq?.icon,
      isCommonLanding: true,
      "data-test-id": "CommonLandingBottomComp-LandingFaq"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonLandingBottomComp);

/***/ }),

/***/ 21348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _CommonModalDweb_CommonModalDweb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33270);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const SegmentModal = ({
  modal,
  onClose,
  onPrimaryCta,
  onSecondaryCta
}) => {
  if (!modal) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_CommonModalDweb_CommonModalDweb__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    customIcon: modal.icon,
    customTitle: modal.title,
    handleClick: onClose,
    nonClipHeading: true,
    "data-test-id": "SegmentModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
      fontSize: "md",
      color: "#757575",
      margin: "0 0 36px",
      "data-test-id": "SegmentModal-ParaTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
        value: modal.description,
        "data-test-id": "SegmentModal-FormattedText"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      "data-test-id": "SegmentModal-FlexComp",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
        handleClick: onSecondaryCta || onClose,
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "SegmentModal-AnchorTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: modal.secondaryCtaText,
          "data-test-id": "SegmentModal-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
        handleClick: onPrimaryCta || onClose,
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "SegmentModal-AnchorTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: modal.primaryCtaText,
          "data-test-id": "SegmentModal-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SegmentModal);

/***/ }),

/***/ 39881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": () => (/* binding */ CommonModalDwebStyle),
/* harmony export */   "G7": () => (/* binding */ CrossIconWrap),
/* harmony export */   "fm": () => (/* binding */ CommonModalHeader)
/* harmony export */ });
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _SectionDividers_SectionDividers_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52287);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93139);
/* harmony import */ var _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40599);





const modalAnim = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalDwebStyle",
  componentId: "sc-1s62ue-0"
})(["position:fixed;width:", ";height:fit-content;max-height:531px;min-height:200px;overflow-y:scroll;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", _SectionDividers_SectionDividers_style__WEBPACK_IMPORTED_MODULE_2__/* .SectionDividersStyle */ .$, _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_4__/* .TMInputWrap */ .dd, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, modalAnim, _TMFloatingInput_TMFloatingInput_style__WEBPACK_IMPORTED_MODULE_4__/* .TMInputWrap */ .dd);
const CommonModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CommonModalHeader",
  componentId: "sc-1s62ue-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:flex-start;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:80%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_3__/* .H5TagStyle */ .Wl, p => p.nonClipHeading && `
     ${_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_3__/* .H5TagStyle */ .Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const CrossIconWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonModalDwebstyle__CrossIconWrap",
  componentId: "sc-1s62ue-2"
})(["flex-shrink:0;cursor:pointer;"]);

/***/ }),

/***/ 33270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39881);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const CommonModalDweb = ({
  children,
  customTitle,
  handleClick,
  requiredField,
  crossIcon,
  customWidth,
  customIcon,
  errorModal,
  nonClipHeading,
  customTitleComponent
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ReactPortalComp, {
    "data-test-id": "CommonModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_1__/* .CommonModalDwebStyle */ .E5, {
      customWidth: customWidth,
      "data-test-id": "CommonModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_1__/* .CommonModalHeader */ .fm, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "CommonModalDweb-CommonModalHeader",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.H5Tag, {
          color: errorModal ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.redText */ .rS.redText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.blackText */ .rS.blackText,
          "data-test-id": "CommonModalDweb-H5Tag",
          children: [customIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
            width: "40px",
            height: "40px",
            src: customIcon,
            "data-test-id": "CommonModalDweb-ImageComponent"
          }), customTitleComponent, customTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
            value: customTitle,
            "data-test-id": "CommonModalDweb-FormattedText"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_1__/* .CrossIconWrap */ .G7, {
          onClick: handleClick,
          "data-test-id": "CommonModalDweb-CrossIconWrap",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "CommonModalDweb-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.BackDropComp, {
      onClose: handleClick,
      "data-test-id": "CommonModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonModalDweb);

/***/ }),

/***/ 33701:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ComparePlan_ComparePlan)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var useBreakpoint = __webpack_require__(53293);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.style.ts
var LandingButton_style = __webpack_require__(45590);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.style.ts




const BenefitRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitRow",
  componentId: "sc-1pkokku-0"
})(["display:flex;border-bottom:1px solid #d3d9df;gap:10px;", " ", "{height:32px;}", " span{font-size:12px;}@media ", "{gap:0;}"], p => p.lastRow && `
    border-bottom: none;
    `, LandingButton_style/* LandingButtonStyle */.zm, LandingButton_style/* LandingButtonStyle */.zm, src.deviceType.mobile);
const BenefitCol1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol1",
  componentId: "sc-1pkokku-1"
})(["display:flex;gap:10px;flex:1.5;padding:12px;@media ", "{padding:12px 4px;flex:1.7;}"], src.deviceType.mobile);
const BenefitCol2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol2",
  componentId: "sc-1pkokku-2"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{border-right:none;padding:12px 10px;", "}"], p => p.firstRow && `
    border-top:solid 1px #d3d9df;
    border-radius:8px 8px 0 0;
    `, p => p.lastRow && `
    border-bottom:solid 1px #d3d9df;
    border-radius:0 0 8px 8px;
    `, src.deviceType.mobile, p => p.firstRow && `
    border-radius:8px 0px 0 0;
    `);
const BenefitCol3 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitCol3",
  componentId: "sc-1pkokku-3"
})(["flex:1.2;display:flex;flex-direction:column;gap:10px;border-left:solid 1px #d3d9df;border-right:solid 1px #d3d9df;padding:12px;", " ", " @media ", "{padding:12px 10px;", "}"], p => p.firstRow && `
    border-top:solid 1px #d3d9df;
    border-radius:8px 8px 0 0;
    `, p => p.lastRow && `
    border-bottom:solid 1px #d3d9df;
    border-radius:0 0 8px 8px;
    `, src.deviceType.mobile, p => p.firstRow && `
    border-top:solid 1px #d3d9df;
    border-radius:0px 8px 0 0;
    `);
const BenefitDescHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ComparePlanstyle__BenefitDescHeader",
  componentId: "sc-1pkokku-4"
})(["background:rgba(0,0,0,0.04);border-radius:4px;display:flex;gap:10px;", "{flex-shrink:0;}@media ", "{gap:0;}"], TextStyles_style/* SpanTagStyle */.zs, src.deviceType.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanBenefit.tsx







const PlanBenefit = ({
  benefitData,
  quoteID1,
  quoteID2
}) => {
  const device = (0,useBreakpoint/* useBreakpoint */.G)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
    "data-test-id": "PlanBenefit-BenefitRow",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol1, {
      "data-test-id": "PlanBenefit-BenefitCol1",
      children: [benefitData?.label?.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: benefitData?.label?.icon,
        height: "20",
        width: "20",
        "data-test-id": "PlanBenefit-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        "data-test-id": "PlanBenefit-SpanTag",
        children: benefitData?.label?.text && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: benefitData?.label?.text,
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
      "data-test-id": "PlanBenefit-BenefitCol2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData?.data?.[quoteID1]?.text ? Global/* theme.blackText */.rS.blackText : Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "PlanBenefit-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: benefitData?.data?.[quoteID1] || "NA",
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
      "data-test-id": "PlanBenefit-BenefitCol3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: device == "lg" ? "black" : "bold",
        color: benefitData?.data?.[quoteID2] ? Global/* theme.blackText */.rS.blackText : Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "PlanBenefit-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: benefitData?.data?.[quoteID2] || "NA",
          "data-test-id": "PlanBenefit-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const ComparePlan_PlanBenefit = (PlanBenefit);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTable.tsx










const PlanTable = ({
  data,
  quoteID1,
  quoteID2
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [data?.header && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
      lastRow: true,
      "data-test-id": "PlanTable-BenefitRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
        "data-test-id": "PlanTable-BenefitCol1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
        firstRow: true,
        "data-test-id": "PlanTable-BenefitCol2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: Global/* theme.purpleTxt */.rS.purpleTxt,
          "data-test-id": "PlanTable-SpanTag",
          children: data?.header?.[quoteID1] && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: data?.header?.[quoteID1],
            "data-test-id": "PlanTable-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
        firstRow: true,
        "data-test-id": "PlanTable-BenefitCol3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          fontWeight: "black",
          color: Global/* theme.berryTxt */.rS.berryTxt,
          "data-test-id": "PlanTable-SpanTag",
          children: data?.header?.[quoteID2] && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: data?.header?.[quoteID2],
            "data-test-id": "PlanTable-FormattedText"
          })
        })
      })]
    }), data?.body && data?.body.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: item.type == "benefit" ? /*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanBenefit, {
          benefitData: item,
          quoteID1: quoteID1,
          quoteID2: quoteID2,
          "data-test-id": `PlanTable-PlanBenefit-${index}`
        }, index) : /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitDescHeader, {
          "data-test-id": "PlanTable-BenefitDescHeader",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
            "data-test-id": "PlanTable-BenefitCol1",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: device == "lg" ? Global/* theme.blackText */.rS.blackText : Global/* theme.greyText7 */.rS.greyText7,
              fontWeight: device == "lg" ? "black" : "bold",
              textTransform: device == "sm" ? "uppercase" : undefined,
              "data-test-id": "PlanTable-SpanTag",
              children: item.label.text
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol2, {
            "data-test-id": "PlanTable-BenefitCol2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol3, {
            "data-test-id": "PlanTable-BenefitCol3"
          })]
        })
      });
    })]
  });
};

/* harmony default export */ const ComparePlan_PlanTable = (PlanTable);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/PlanTableFooter.tsx







const PlanTableFooter = ({
  btn1Handler,
  btn2Handler,
  footerData,
  quoteID1,
  quoteID2
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitRow, {
    lastRow: true,
    "data-test-id": "PlanTableFooter-BenefitRow",
    children: [footerData && /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitCol1, {
      "data-test-id": "PlanTableFooter-BenefitCol1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: footerData?.label && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: footerData?.label,
          "data-test-id": "PlanTableFooter-FormattedText"
        })
      })
    }), footerData && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol2, {
      lastRow: true,
      "data-test-id": "PlanTableFooter-BenefitCol2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          "data-test-id": "PlanTableFooter-SpanTag",
          children: footerData?.data?.[quoteID1]?.label && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: footerData?.data?.[quoteID1]?.label,
            "data-test-id": "PlanTableFooter-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        onClick: btn1Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%",
        "data-test-id": "PlanTableFooter-LandingButton"
      })]
    }), footerData && /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitCol3, {
      lastRow: true,
      "data-test-id": "PlanTableFooter-BenefitCol3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        "data-test-id": "PlanTableFooter-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontSize: "xs",
          fontWeight: "bold",
          "data-test-id": "PlanTableFooter-SpanTag",
          children: footerData?.data?.[quoteID2]?.label && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: footerData?.data?.[quoteID2]?.label,
            "data-test-id": "PlanTableFooter-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        onClick: btn2Handler,
        customTitle: device == "lg" ? "BUY PLAN" : "BUY",
        customWidth: "100%",
        "data-test-id": "PlanTableFooter-LandingButton"
      })]
    })]
  });
};

/* harmony default export */ const ComparePlan_PlanTableFooter = (PlanTableFooter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.tsx







const ComparePlan = ({
  handleClose,
  modalTitle,
  data,
  handleBuyButton,
  productId1ForCompare,
  quoteId1ForCompare,
  productId2ForCompare,
  quoteId2ForCompare
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDweb/* default */.Z, {
    customWidth: "524px",
    customTitle: modalTitle,
    handleClick: handleClose,
    "data-test-id": "ComparePlan-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanTable, {
      data: data,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare,
      "data-test-id": "ComparePlan-PlanTable"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ComparePlan_PlanTableFooter, {
      btn1Handler: () => handleBuyButton(quoteId1ForCompare, productId1ForCompare),
      btn2Handler: () => handleBuyButton(quoteId2ForCompare, productId2ForCompare),
      footerData: data?.footer,
      quoteID1: quoteId1ForCompare,
      quoteID2: quoteId2ForCompare,
      "data-test-id": "ComparePlan-PlanTableFooter"
    })]
  });
};

/* harmony default export */ const ComparePlan_ComparePlan = (ComparePlan);

/***/ }),

/***/ 67189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ContentBlock_ContentBlock)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ContentBlock/ContentBlock.style.ts


const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContentBlockstyle__Container",
  componentId: "h3nf05-0"
})(["width:100%;padding:30px 0;"]);
const GridContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContentBlockstyle__GridContainer",
  componentId: "h3nf05-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:30px;max-width:1200px;margin:0 auto;"]);
const QnaSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContentBlockstyle__QnaSection",
  componentId: "h3nf05-2"
})(["", ""], props => `
        &:nth-child(n+3) {
            border-top: 1px solid #979797;
            padding-top: 30px;
        }
    `);
const Question = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "ContentBlockstyle__Question",
  componentId: "h3nf05-3"
})(["font-weight:700;font-size:16px;line-height:22px;margin-bottom:25px;color:", ";"], Global/* theme.blackText */.rS.blackText);
const Answer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ContentBlockstyle__Answer",
  componentId: "h3nf05-4"
})(["font-size:12px;line-height:16px;color:", ";cursor:pointer;position:relative;margin-bottom:", ";", " ul,ol{margin:8px 0;padding-left:20px;list-style:disc;}li{margin-bottom:4px;}"], Global/* theme.greyText */.rS.greyText, props => props.isExpanded ? "0" : "8px", props => !props.isExpanded ? `
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  ` : "");
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ContentBlock/ContentBlock.tsx





const ContentBlock = ({
  data
}) => {
  const qnaData = data || []; // || LOCAL_CONTENT_BLOCK_INFO;

  const {
    0: expandedItems,
    1: setExpandedItems
  } = (0,react.useState)(new Set());

  const toggleExpand = index => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);

      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }

      return newSet;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
    "data-test-id": "ContentBlock-Container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridContainer, {
      "data-test-id": "ContentBlock-GridContainer",
      children: qnaData?.map((item, index) => {
        const isExpanded = expandedItems.has(index);
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(QnaSection, {
          index: index,
          "data-test-id": `ContentBlock-QnaSection-${index}`,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
            "data-test-id": "ContentBlock-Question",
            children: item?.heading
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Answer, {
            isExpanded: isExpanded,
            onClick: () => toggleExpand(index),
            dangerouslySetInnerHTML: {
              __html: item?.description || ""
            },
            "data-test-id": "ContentBlock-Answer"
          })]
        }, index);
      })
    })
  });
};

/* harmony default export */ const ContentBlock_ContentBlock = (ContentBlock);

/***/ }),

/***/ 21864:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ CountryCodeInput_CountryCodeInput)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.style.ts


const InputWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryCodeInputstyle__InputWrap",
  componentId: "sc-18gzilo-0"
})(["position:relative;display:flex;flex-direction:column;margin:", ";width:", ";flex:", ";flex-shrink:0;label{font-weight:900;font-size:14px;line-height:16px;color:#4a4a4a;display:block;margin-bottom:8px;transition:all 0.3s ease;display:inline-block;}"], props => props.margin, props => props.inputWidth, p => p.flex ? p.flex : "");
const ErrorTxt = (0,styled_components_browser_esm/* default */.ZP)(TextStyles_style/* SpanTagStyle */.zs).withConfig({
  displayName: "CountryCodeInputstyle__ErrorTxt",
  componentId: "sc-18gzilo-1"
})(["color:#eb2026;"]);
const LandingInputStyle = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "CountryCodeInputstyle__LandingInputStyle",
  componentId: "sc-18gzilo-2"
})(["background:", ";border:1px solid #d2d2d2;border-radius:4px;padding:10px 10px 10px 64px;font-weight:900;font-size:14px;line-height:19px;display:block;&::placeholder{font-weight:400;}&:focus + label{color:var(--tm-accent-color);}", " ", " ", " &:focus{outline:none;border:1px solid var(--tm-accent-color);background:var(--tm-accent-bg-color);}&[type=\"number\"]::-webkit-outer-spin-button,&[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=\"number\"]{-moz-appearance:textfield;}"], props => props.backgroundColor || "#ffffff", props => props.disableState && `
      opacity: 0.3;
      pointer-events: none;
	`, props => props.errorState && `
      border: 1px solid #EB2026;
	`, props => props.Verify && `
      color: #008CFF;
      background: var(--tm-accent-bg-color);
      border: 1px solid var(--tm-accent-color);
      pointer-events: none;
	`);
const CounryCodeWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CountryCodeInputstyle__CounryCodeWrap",
  componentId: "sc-18gzilo-3"
})(["display:flex;align-items:center;gap:8px;position:absolute;left:16px;top:39px;z-index:1;cursor:pointer;&:after{content:\"\";position:absolute;top:5px;right:-13px;border:solid var(--tm-accent-color);border-width:0 2px 2px 0;display:inline-block;padding:3px;transform:rotate(45deg);-webkit-transform:rotate(45deg);}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.tsx







const CountryCodeInput = ({
  placeholderTxt,
  labelTxt,
  disableState,
  inputWidth,
  margin,
  errorState,
  inputValue,
  handleChange,
  handleBlur,
  Verify,
  flex,
  requiredField,
  handleKeyDown,
  maxInputLength,
  inputType,
  handleCountryCodeModal,
  countryCode,
  countryFlag,
  autoComplete = "on",
  isDisabled = false,
  backgroundColor
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputWrap, {
    margin: margin,
    flex: flex,
    inputWidth: inputWidth,
    Verify: Verify,
    "data-test-id": "CountryCodeInput-InputWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CounryCodeWrap, {
      onClick: handleCountryCodeModal,
      "data-test-id": "CountryCodeInput-CounryCodeWrap",
      children: [countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        src: countryFlag,
        "data-test-id": "CountryCodeInput-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "black",
        "data-test-id": "CountryCodeInput-SpanTag",
        children: countryCode
      })]
    }), labelTxt && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: labelTxt,
      "data-test-id": "CountryCodeInput-label",
      children: [labelTxt, requiredField && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "bold",
        color: Global/* theme.redText2 */.rS.redText2,
        "data-test-id": "CountryCodeInput-SpanTag",
        children: "*"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInputStyle, {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      value: inputValue,
      errorState: errorState,
      id: labelTxt,
      disableState: disableState,
      placeholder: placeholderTxt,
      maxLength: maxInputLength,
      type: inputType,
      autoComplete: autoComplete,
      disabled: isDisabled,
      backgroundColor: backgroundColor,
      "data-test-id": "CountryCodeInput-LandingInputStyle"
    }), errorState && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTxt, {
      txtfontSize: "xs",
      margin: "4px 0 0",
      color: Global/* theme.redText */.rS.redText,
      txtfontWeight: "bold",
      "data-test-id": "CountryCodeInput-ErrorTxt",
      children: errorState
    })]
  });
};

/* harmony default export */ const CountryCodeInput_CountryCodeInput = (CountryCodeInput);

/***/ }),

/***/ 78525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);





function CountryFormatter({
  title
}) {
  const {
    0: country,
    1: setCountry
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const {
    0: count,
    1: setCount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const COUNTRY_FORMATTER_MAX_LENGTH = 35;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (title && title?.length > COUNTRY_FORMATTER_MAX_LENGTH) {
      const tempCountry = title?.substring(0, COUNTRY_FORMATTER_MAX_LENGTH)?.split(/[,&]/);

      if (tempCountry.length > 1) {
        tempCountry.pop();
      }

      setCountry(tempCountry?.join(", "));
      const tempCount = title && title?.split(/[,&]/).length - tempCountry.length;
      setCount(tempCount);
    } else {
      setCountry(title);
    }
  }, [title]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [country, title && title?.length > COUNTRY_FORMATTER_MAX_LENGTH ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      style: {
        fontSize: 12,
        marginLeft: 0,
        color: "#9B9B9B"
      },
      "data-test-id": "",
      children: ` ...  ${count && count > 0 ? `+${count} more` : ""}`
    }) : null]
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CountryFormatter);

/***/ }),

/***/ 85607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ns": () => (/* binding */ DatePickerWrap),
/* harmony export */   "PK": () => (/* binding */ ErrorToast),
/* harmony export */   "T7": () => (/* binding */ DateLabel),
/* harmony export */   "bZ": () => (/* binding */ DatePickerHeader),
/* harmony export */   "cM": () => (/* binding */ DatePickerHeaderInner),
/* harmony export */   "fU": () => (/* binding */ DateTab),
/* harmony export */   "vi": () => (/* binding */ DateTabList),
/* harmony export */   "wH": () => (/* binding */ DobPickerStyle)
/* harmony export */ });
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _Toast_Toast_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67929);



const DatePickerWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerWrap",
  componentId: "sc-128qnt3-0"
})(["width:592px;background:#ffffff;box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;.calenderHeader{margin-top:0;}", "{position:static;background:#fcdadb;width:fit-content;margin-bottom:16px;margin-left:16px;}", " span{font-size:14px;color:", ";}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:var(--tm-accent-bg-color-dark);color:#000;border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:var(--tm-accent-color);border-radius:0px 2px 2px 0px;color:#fff;}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:#9b9b9b;}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:#000;}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:var(--tm-accent-bg-color-dark);border-radius:0;}&.single-date-mode .rdp-day_selected,&.single-date-mode .rdp-day_selected:focus-visible{background:#008cff;color:#fff;border-radius:2px;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:var(--tm-accent-color);border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px var(--tm-accent-color);border-left:solid 2px var(--tm-accent-color);}"], _Toast_Toast_style__WEBPACK_IMPORTED_MODULE_2__/* .ToastStyle */ .jf, _Toast_Toast_style__WEBPACK_IMPORTED_MODULE_2__/* .ToastStyle */ .jf, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.redText */ .rS.redText);
const DatePickerHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerHeader",
  componentId: "sc-128qnt3-1"
})(["padding:8px;background-color:#fff;"]);
const DatePickerHeaderInner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DatePickerHeaderInner",
  componentId: "sc-128qnt3-2"
})(["padding:8px;border-radius:4px;background-color:#eaf5ff;"]);
const DateLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DateLabel",
  componentId: "sc-128qnt3-3"
})(["background:#ffffff;border-radius:2px;padding:0 8px;", ""], p => p.activeTab && `
    background: var(--tm-accent-bg-color);
    border: 1px solid var(--tm-accent-color);
    border-radius: 2px;
    `);
const DateTab = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "DatePickerCompstyle__DateTab",
  componentId: "sc-128qnt3-4"
})(["display:flex;padding:10px 15px;border-radius:4px 4px 0px 0px;background-color:#f2f2f2;"]);
const DateTabList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "DatePickerCompstyle__DateTabList",
  componentId: "sc-128qnt3-5"
})(["cursor:pointer;display:flex;align-items:center;gap:4px;margin-right:10px;&:last-child{margin-right:unset;}"]);
const ErrorToast = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__ErrorToast",
  componentId: "sc-128qnt3-6"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
const DobPickerStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DatePickerCompstyle__DobPickerStyle",
  componentId: "sc-128qnt3-7"
})(["border-radius:4px;border:0px solid #979797;background:#fff;box-shadow:0px 1px 6px 0px rgba(0,0,0,0.2);width:300px;.rdp-dropdown_year,.rdp-dropdown_month{border-radius:4px;border:1px solid #4a4a4a;padding:0 8px;}.rdp-day_selected,.rdp-day_selected:focus-visible,.rdp-day_selected:hover{border-radius:2px 0px 0px 2px;background:var(--tm-accent-color);color:#fff;}.rdp-head{color:#9b9b9b;text-align:center;font-size:12px;font-weight:700;}.rdp-weeknumber,.rdp-day{font-size:12px;}"]);

/***/ }),

/***/ 85891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_day_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50530);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42874);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84576);
/* harmony import */ var _DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85607);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52322);









const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const DatePickerComp = ({
  startDateLabel,
  endDateLabel,
  from,
  to,
  maxEndDate,
  dateTab,
  handleDateTab,
  handleDayClick,
  selected,
  showToast,
  toastMessage,
  minStartDate,
  isSingleDate,
  onSingleDateSelect,
  calenderHeader
}) => {
  const weekDayNameFormatter = date => {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
      "data-test-id": "DatePickerComp-weekDayNameFormatter",
      children: date.toDateString()[0]
    });
  };

  const monthNameFormatter = date => {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
      "data-test-id": "DatePickerComp-monthNameFormatter",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("b", {
        "data-test-id": "DatePickerComp-monthNameFormatter-b",
        children: MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  const disabledDays = date => {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .isBefore */ .RRz)((0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b7Q)(date), (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b7Q)(new Date())) || !!(maxEndDate && (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .isAfter */ .AxD)(date, maxEndDate)) || !!(minStartDate && (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .isBefore */ .RRz)((0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b7Q)(date), (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .startOfDay */ .b7Q)(minStartDate)));
  };

  const {
    0: currentMonth,
    1: setCurrentMonth
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(new Date());
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (from && to) {
      setCurrentMonth(from);
    }
  }, [from, to]);

  const handleMonthChange = month => {
    setCurrentMonth(month);
  };

  const toastRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (showToast && toastRef.current) {
      window.scrollTo({
        top: toastRef.current.offsetTop - 100,
        behavior: "smooth"
      });
    }
  }, [showToast]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DatePickerWrap */ .Ns, {
    id: "datePickerContainer",
    className: isSingleDate ? "single-date-mode" : "",
    "data-test-id": "DatePickerComp-DatePickerWrap",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateTab */ .fU, {
      "data-test-id": "DatePickerComp-DateTab",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateTabList */ .vi, {
        onClick: () => handleDateTab?.(0),
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: startDateLabel
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateLabel */ .T7, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
            fontSize: "sm",
            fontWeight: dateTab == 0 ? "bold" : "regular",
            color: dateTab == 0 ? `var(--tm-accent-color)` : _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: from ? (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .calendarLabelFormatter */ .IZ)(from) : "Select"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateTabList */ .vi, {
        "data-test-id": "DatePickerComp-DateTabList",
        children: "-"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateTabList */ .vi, {
        onClick: () => !isSingleDate && handleDateTab?.(1),
        style: {
          cursor: isSingleDate ? "not-allowed" : "pointer",
          opacity: isSingleDate ? 0.5 : 1
        },
        "data-test-id": "DatePickerComp-DateTabList",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.175 3.49118V2.35529H9.90518V3.49118H6.09566V2.35529H4.82582C4.82582 1.94366 4.82582 3.49118 4.82582 3.49118L3.55597 3.49118C2.85121 3.49118 2.29248 4.00233 2.29248 4.62707L2.28613 12.5783C2.28613 13.2031 2.85121 13.7142 3.55597 13.7142H12.4449C13.1433 13.7142 13.7147 13.2031 13.7147 12.5783V4.62707C13.7147 4.00233 13.1433 3.49118 12.4449 3.49118H11.175ZM12.4449 12.5783H3.55597V5.76296H12.4449V12.5783ZM5.01319 6.89886H7.2989V9.18457H5.01319V6.89886Z",
            fill: "#9B9B9B"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
          fontSize: "sm",
          "data-test-id": "DatePickerComp-SpanTag",
          children: endDateLabel
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DateLabel */ .T7, {
          activeTab: dateTab == 0,
          "data-test-id": "DatePickerComp-DateLabel",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
            fontWeight: dateTab == 1 && !isSingleDate ? "bold" : "regular",
            fontSize: "sm",
            color: isSingleDate ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText : dateTab == 1 ? `var(--tm-accent-color)` : _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "DatePickerComp-SpanTag",
            children: to ? (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .calendarLabelFormatter */ .IZ)(to) : "Select"
          })
        })]
      })]
    }), calenderHeader?.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DatePickerHeader */ .bZ, {
      "data-test-id": "DatePickerComp-DatePickerHeader",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .DatePickerHeaderInner */ .cM, {
        "data-test-id": "DatePickerComp-DatePickerHeaderInner",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
          value: calenderHeader?.title,
          "data-test-id": "DatePickerComp-FormattedText"
        })
      })
    }), isSingleDate ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_day_picker__WEBPACK_IMPORTED_MODULE_2__/* .DayPicker */ ._W, {
      className: calenderHeader?.title ? "calenderHeader" : "",
      mode: "single",
      numberOfMonths: 2,
      selected: from,
      disabled: disabledDays,
      onDayClick: date => {
        if (isSingleDate && onSingleDateSelect) {
          onSingleDateSelect(date);
        } else if (handleDayClick) {
          handleDayClick(date, {}, {});
        }
      },
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      },
      month: currentMonth,
      onMonthChange: handleMonthChange,
      "data-test-id": "DatePickerComp-DayPicker"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_day_picker__WEBPACK_IMPORTED_MODULE_2__/* .DayPicker */ ._W, {
      mode: "range",
      numberOfMonths: 2,
      selected: selected,
      disabled: disabledDays,
      onDayClick: handleDayClick,
      formatters: {
        formatWeekdayName: weekDayNameFormatter,
        formatCaption: monthNameFormatter
      },
      month: currentMonth,
      onMonthChange: handleMonthChange,
      "data-test-id": "DatePickerComp-DayPicker"
    }), showToast && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_DatePickerComp_style__WEBPACK_IMPORTED_MODULE_6__/* .ErrorToast */ .PK, {
      ref: toastRef,
      "data-test-id": "DatePickerComp-ErrorToast",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.redText */ .rS.redText,
        "data-test-id": "DatePickerComp-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
          value: toastMessage,
          "data-test-id": "DatePickerComp-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DatePickerComp);

/***/ }),

/***/ 57989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DescriptionModal_DescriptionModal)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.tsx + 1 modules
var RegionModalDweb = __webpack_require__(47233);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.style.tsx

const PopularDescriptionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DescriptionModalstyle__PopularDescriptionWrap",
  componentId: "sc-7zo3r7-0"
})(["border-radius:4px;padding:12px;background-color:#f6f6f6;"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DescriptionModal/DescriptionModal.tsx







const DescriptionModal = ({
  handleDescriptionModal,
  value,
  title
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegionModalDweb/* default */.Z, {
    handleClick: handleDescriptionModal,
    customTitle: title,
    "data-test-id": "DescriptionModal-RegionModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PopularDescriptionWrap, {
      "data-test-id": "DescriptionModal-PopularDescriptionWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: "Countries Covered: ",
        baseStyle: {
          fontWeight: "bold",
          color: Global/* theme.greyText */.rS.greyText,
          fontSize: "xs"
        },
        "data-test-id": "DescriptionModal-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: value,
        "data-test-id": "DescriptionModal-FormattedText"
      })]
    })
  });
};

/* harmony default export */ const DescriptionModal_DescriptionModal = (DescriptionModal);

/***/ }),

/***/ 97868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DesktopLayout_DesktopLayout)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(71040);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Chatbot/Chatbot.tsx + 3 modules
var Chatbot = __webpack_require__(73232);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravelPlexBot/TravelPlexBot.tsx + 1 modules
var TravelPlexBot = __webpack_require__(16641);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.style.ts
var LandingButton_style = __webpack_require__(45590);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.style.ts




const DesktopLayoutStyleSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSectionWrap",
  componentId: "ylfaze-0"
})(["position:relative;padding-top:6px;img,picture{flex-shrink:0;}&:after{position:fixed;width:100%;background-image:", ";background-repeat:no-repeat;background-size:cover;content:\"\";top:0;left:0;height:87%;z-index:1;}", " @media ", "{padding-top:0px;&:after{height:0;background:transparent;background-image:none;}}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `url("https://tripmoneycmsimgak.mmtcdn.com/img/BG_e367ef5372.png")` : `url("https://tripmoneycmsimgak.mmtcdn.com/img/blue_Grad_Bg_563cf7d36a.png")`, p => (p.theme.pageTheme === isomorphic_utils_src.PARTNER.MMT || p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ) && p.landingPageProp ? `
        &:after {
        background:transparent;
        }
        ${LandingButton_style/* LandingButtonStyle */.zm}{
            border-radius:38px;
        }
` : p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI && p.landingPageProp ? `
    &:after {
    background:transparent;
    }
    ${LandingButton_style/* LandingButtonStyle */.zm}{
        border-radius:30px;
    }
` : "", utils/* deviceType.mobile */.vO.mobile);
const DesktopLayoutStyleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutStyleSection",
  componentId: "ylfaze-1"
})(["width:", ";margin:0 auto;display:flex;gap:", ";height:100%;z-index:3;position:relative;justify-content:space-between;align-items:", ";flex-direction:", ";margin-bottom:", ";background:", ";", " ", " @media ", "{background:#f2f2f2;width:100%;gap:24px;padding:56px 16px 0;margin-top:0;border-radius:0px;background-image:", ";background-repeat:no-repeat;background-size:contain;flex-direction:column;", "}"], p => p.landingMargin ? "1200px" : "1230px", p => p.landingMargin ? "88px" : "58px", p => p.alignCenter ? "flex-start" : "baseline", p => p.flexDirection ? "column" : "row", p => p.landingMargin ? "70px" : "", p => p.landingMargin ? "#fff" : "transparent", p => (p.theme.pageTheme === isomorphic_utils_src.PARTNER.MMT || p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ) && p.landingMargin ? `
            padding:84px 40px 40px;
            border-radius:10px;
            margin-top:26px;
` : p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI && p.landingMargin ? `
            padding:38px 40px 40px;
            border-radius:10px;
            margin-top:26px;
` : "", p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ && p.landingMargin ? `
    padding: 100px 40px 40px;
    box-shadow: 0px 3px 30px 0px #0000001A;` : "", utils/* deviceType.mobile */.vO.mobile, p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `url("https://tripmoneycmsimgak.mmtcdn.com/img/MOB_BG_4b6173db81.png")` : `url("https://tripmoneycmsimgak.mmtcdn.com/img/mob_Bg_76aceb3f35.png")`, p => p.landingMargin && `
            padding-bottom: 238px;
            margin-bottom: -236px ;
        `);
const DesktopLayoutBotttomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutBotttomSection",
  componentId: "ylfaze-2"
})(["margin-top:20px;display:flex;gap:80px;height:100%;z-index:2;position:relative;align-items:flex-start;flex-direction:column;@media ", "{gap:56px;z-index:3;}"], utils/* deviceType.mobile */.vO.mobile);
const DesktopLayoutLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutLeftSection",
  componentId: "ylfaze-3"
})(["display:flex;flex-direction:column;align-self:flex-start;padding-top:", ";gap:32px;margin:", ";height:", ";flex:1;margin-left:", ";position:", ";top:155px;width:498px;", " ", ";@media ", "{margin-left:0;margin-top:11px;padding-top:0;height:unset;gap:10px;position:static;width:100%;}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? "50px" : p.leftSectionHeight ? "" : "0px", p => p.leftSectionMargin ? p.leftSectionMargin : "", p => p.leftSectionHeight ? "100%" : "calc(708px - 130px)", p => p.leftSectionHeight ? "" : "15px", p => p.leftPositionSticky ? "sticky" : "", p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MMT && p.leftSectionHeight ? `
            margin-top:40px;
` : p.theme.pageTheme === isomorphic_utils_src.PARTNER.GI ? `
            margin-top:40px;
` : "", p => p.leftPositionSticky ? `` : `margin-top:50px;`, utils/* deviceType.mobile */.vO.mobile);
const DesktopLayoutRightSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutRightSection",
  componentId: "ylfaze-4"
})(["width:", ";flex-shrink:0;padding-bottom:", ";display:flex;flex-direction:column;z-index:1;gap:16px;padding:", ";margin-right:", ";min-height:490px;justify-content:", ";&::-webkit-scrollbar{display:none;}@media ", "{width:100%;overflow-y:unset;padding:0;margin-right:0;height:unset;", "}"], p => p.rightSectionHeight ? "592px" : "622px", p => p.rightSectionHeight ? "" : "40px", p => p.rightSectionHeight ? "" : "56px 30px 0", p => p.rightSectionHeight ? "" : "-15px", p => p.showMyOrder ? "normal" : "flex-end", utils/* deviceType.mobile */.vO.mobile, p => !p.rightSectionHeight && `
        margin-right: -16px;
        margin-left: -16px;
        width: -webkit-fill-available;
        overflow-y: scroll;
        flex-shrink:unset;
        `);
const DesktopLayoutHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DesktopLayoutstyle__DesktopLayoutHeading",
  componentId: "ylfaze-5"
})(["display:flex;flex-direction:column;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.tsx












const DesktopLayout = ({
  title,
  chatBotInfo,
  leftComp,
  rightComp,
  bottomComp,
  headingComp,
  height,
  alignCenter,
  leftSectionMargin,
  rightSectionHeight,
  leftSectionHeight,
  landingMargin,
  subTitle,
  shimmer,
  landingPageProp,
  goToMyOrders,
  showMyOrder,
  pageName,
  chatbotBottomMargin,
  leftPositionSticky = true
}) => {
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: windowHeight,
    1: setWindowHeight
  } = (0,react.useState)(undefined);
  (0,react.useEffect)(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    if (true) {
      setWindowHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (true) {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  const getChatbot = () => {
    if (!chatBotInfo?.isEnabled) {
      return null;
    }

    if (chatBotInfo.type === "MYRA") {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Chatbot/* default */.Z, {
        pageName: pageName,
        myraUrl: chatBotInfo.myraUrl,
        chatbotBottomMargin: chatbotBottomMargin,
        "data-test-id": "DesktopLayout-getChatbot-Chatbot"
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelPlexBot/* default */.Z, {
      view: pageName,
      "data-test-id": "DesktopLayout-getChatbot-TravelPlexBot"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSectionWrap, {
    id: "pageId",
    height: height,
    landingPageProp: landingPageProp,
    "data-test-id": "DesktopLayout-DesktopLayoutStyleSectionWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutStyleSection, {
      landingMargin: landingMargin,
      alignCenter: alignCenter,
      "data-test-id": "DesktopLayout-DesktopLayoutStyleSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutLeftSection, {
        leftSectionHeight: leftSectionHeight,
        leftSectionMargin: leftSectionMargin,
        leftPositionSticky: leftPositionSticky,
        "data-test-id": "DesktopLayout-DesktopLayoutLeftSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: shimmer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            flexDirection: "column",
            gap: "4px",
            "data-test-id": "DesktopLayout-FlexComp",
            children: [subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.Shimmer, {
              width: "375px",
              height: "38px",
              "data-test-id": "DesktopLayout-Shimmer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.Shimmer, {
              width: "100%",
              height: "56px",
              "data-test-id": "DesktopLayout-Shimmer"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [subTitle && (device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H4Tag, {
              margin: device == "lg" ? "40px 0 0" : "",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
              fontSize: "md",
              fontWeight: "black",
              color: "#CF8100",
              "data-test-id": "DesktopLayout-ParaTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: subTitle,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
              "data-test-id": "DesktopLayout-H2Tag",
              children: title ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              }) : null
            }) : title?.html ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: title,
              "data-test-id": "DesktopLayout-FormattedText"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H4Tag, {
              "data-test-id": "DesktopLayout-H4Tag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: title,
                "data-test-id": "DesktopLayout-FormattedText"
              })
            })]
          })
        }), leftComp]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopLayoutRightSection, {
        rightSectionHeight: rightSectionHeight,
        showMyOrder: showMyOrder,
        "data-test-id": "DesktopLayout-DesktopLayoutRightSection",
        children: [context && showMyOrder && landingPageProp && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          alignSelf: "flex-end",
          isCursorPointer: true,
          gap: "4px",
          alignItems: "center",
          margin: "0 0 8px",
          "data-test-id": "DesktopLayout-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
            fontWeight: "bold",
            handleClick: goToMyOrders,
            color: `var(--tm-accent-color)`,
            "data-test-id": "DesktopLayout-AnchorTag",
            children: "My Orders"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
            width: 16,
            height: 16,
            "data-test-id": "DesktopLayout-ArrowRight"
          })]
        }), rightComp]
      })]
    }), bottomComp && /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopLayoutBotttomSection, {
      "data-test-id": "DesktopLayout-DesktopLayoutBotttomSection",
      children: bottomComp
    }), getChatbot()]
  });
};

/* harmony default export */ const DesktopLayout_DesktopLayout = (DesktopLayout);

/***/ }),

/***/ 56081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17871);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



const DisclaimerComp = ({
  disclaimer
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    value: disclaimer.info,
    baseStyle: {
      fontWeight: 400,
      color: "#757575",
      fontSize: "12px"
    },
    "data-test-id": "DisclaimerComp-FormattedText"
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DisclaimerComp);

/***/ }),

/***/ 15177:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DnldPolicyComponent_DnldPolicyComponent)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(81594);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.style.ts


const DnldPolicyComponentStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__DnldPolicyComponentStyle",
  componentId: "sc-10opecw-0"
})(["border-radius:6px;background:#fff;padding:20px;@media ", "{padding:16px;}"], utils/* deviceType.mobile */.vO.mobile);
const TravNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__TravNumber",
  componentId: "sc-10opecw-1"
})(["border-radius:100%;background:#f6f6f6;width:16px;height:16px;font-size:12px;font-weight:700;display:flex;justify-content:center;align-items:center;"]);
const PolicyItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DnldPolicyComponentstyle__PolicyItem",
  componentId: "sc-10opecw-2"
})(["display:flex;gap:18px;align-items:baseline;padding:12px 16px;border:1px solid #e2e2e2;border-top:none;", ""], p => p.firstChild && `border-top: 1px solid #e2e2e2;`);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.tsx







const DnldPolicyComponent = ({
  data,
  travellersInsured
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DnldPolicyComponentStyle, {
    "data-test-id": "DnldPolicyComponent-DnldPolicyComponentStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      gap: "8px",
      alignItems: "center",
      margin: "0 0 24px",
      "data-test-id": "DnldPolicyComponent-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "24px",
        height: "24px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/people_Group_Icon_d97975a5cb.svg",
        "data-test-id": "DnldPolicyComponent-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "black",
        fontSize: "large",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "DnldPolicyComponent-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: travellersInsured,
          "data-test-id": "DnldPolicyComponent-FormattedText"
        })
      })]
    }), data?.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(PolicyItem, {
        firstChild: index == 0,
        "data-test-id": `DnldPolicyComponent-PolicyItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravNumber, {
          "data-test-id": "DnldPolicyComponent-TravNumber",
          children: index + 1
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [item.Title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: "md",
            fontWeight: "black",
            "data-test-id": "DnldPolicyComponent-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.Title,
              "data-test-id": "DnldPolicyComponent-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: item.Description && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "DnldPolicyComponent-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.Description,
                "data-test-id": "DnldPolicyComponent-FormattedText"
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
          margin: "0 0 0 auto",
          textTransform: "uppercase",
          fontWeight: "black",
          hrefProp: item?.Link?.DownloadUrl,
          download: true,
          targetProp: "_blank",
          "data-test-id": "DnldPolicyComponent-AnchorTag",
          children: "Download"
        })]
      }, index);
    })]
  });
};

/* harmony default export */ const DnldPolicyComponent_DnldPolicyComponent = (DnldPolicyComponent);

/***/ }),

/***/ 26146:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DomesticTravelDetail_DomesticTrip)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTravelDetail.style.ts

const DomesticTripStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__DomesticTripStyle",
  componentId: "sc-813ho8-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:8px;"]);
const ContainerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__ContainerStyle",
  componentId: "sc-813ho8-1"
})(["display:flex;", ";", ";"], props => props.flexDirection && `flex-direction: ${props.flexDirection}`, props => props.gap && `gap: ${props.gap}`);
const TagStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__TagStyle",
  componentId: "sc-813ho8-2"
})(["color:#ffffff;padding:2px 8px 2px 8px;font-weight:600;font-size:10px;align-items:center;border-radius:8px 0px 8px 0px;", ";"], props => `background: linear-gradient(45deg, ${props?.startColor ?? "#00d2ff"} 14.64%, ${props?.endColor ?? "#3a7bd5"} 85.36%)`);
const ArrowButtonWrap = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "DomesticTravelDetailstyle__ArrowButtonWrap",
  componentId: "sc-813ho8-3"
})(["display:flex;align-items:center;flex-shrink:0;cursor:pointer;"]);
const BannerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DomesticTravelDetailstyle__BannerStyle",
  componentId: "sc-813ho8-4"
})(["display:flex;background:#eaf5ff;padding:8px 15px 12px 16px;border-radius:0px 0px 8px 8px;gap:8px;font-size:14px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTrip.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const analytics = (0,insurance/* getAnalytics */.I)();

const DomesticTrip = ({
  trips,
  title
}) => {
  const {
    type
  } = (0,src/* usePlanType */.U)();
  (0,react.useEffect)(() => {
    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_shown"
    }, "pageView", type);
    (0,XDMAnalytics.trackComponentView)({
      name: "upcoming_domestic_trips_shown",
      type: "card"
    });
  }, []);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const tripData = trips?.[0];

  const handleDomesticClick = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());

    const params = _objectSpread(_objectSpread({}, queryParams), {}, {
      isUpcomingTrip: true,
      bookingId: trips?.[0]?.bookingId
    });

    analytics?.trackLandingEvents({
      actionType: "upcoming_domestic_trips_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "upcoming_domestic_trips_clicked"
      }
    });
    navigation/* navigationActions.navigateToTravellerDetails */.ej.navigateToTravellerDetails(params);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ContainerStyle, {
    flexDirection: "column",
    gap: "10px",
    "data-test-id": "DomesticTrip-ContainerStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
      value: title,
      baseStyle: {
        color: Global/* theme.blackText */.rS.blackText
      },
      "data-test-id": "DomesticTrip-FormattedText"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DomesticTripStyle, {
      "data-test-id": "DomesticTrip-DomesticTripStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
        "data-test-id": "DomesticTrip-ContainerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagStyle, {
          startColor: tripData?.tag?.startColor,
          endColor: tripData?.tag?.endColor,
          "data-test-id": "DomesticTrip-TagStyle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: tripData?.tag?.title,
            "data-test-id": "DomesticTrip-FormattedText"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 15px 12px 16px",
        handleClick: handleDomesticClick,
        "data-test-id": "DomesticTrip-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
          "data-test-id": "DomesticTrip-SpanTag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: tripData?.description,
            baseStyle: {
              color: "#4A4A4A",
              fontWeight: "400px",
              fontSize: "12px"
            },
            "data-test-id": "DomesticTrip-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            margin: "7px 0px 0px 0px",
            isCursorPointer: true,
            "data-test-id": "DomesticTrip-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "32px",
              height: "32px",
              margin: "0px 8px 0px 0px",
              src: tripData?.image,
              "data-test-id": "DomesticTrip-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                value: tripData?.title,
                baseStyle: {
                  color: "#000000",
                  fontWeight: "700",
                  fontSize: "14px"
                },
                "data-test-id": "DomesticTrip-FormattedText"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContainerStyle, {
                "data-test-id": "DomesticTrip-ContainerStyle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: tripData?.subtitle,
                  baseStyle: {
                    color: "#4A4A4A",
                    fontWeight: "400",
                    fontSize: "12px"
                  },
                  "data-test-id": "DomesticTrip-FormattedText"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButtonWrap, {
          "data-test-id": "DomesticTrip-ArrowButtonWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "9px",
            height: "9px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Right_Blue_448003ff39.svg",
            "data-test-id": "DomesticTrip-ImageComponent"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerStyle, {
        "data-test-id": "DomesticTrip-BannerStyle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: tripData?.banner?.description,
          "data-test-id": "DomesticTrip-FormattedText"
        })
      })]
    })]
  });
};

/* harmony default export */ const DomesticTravelDetail_DomesticTrip = (DomesticTrip);

/***/ }),

/***/ 81291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ DropOffModal_DropOffModal)
});

// UNUSED EXPORTS: DropOffModal

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx
var LandingButton = __webpack_require__(99660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ModalWrapper/ModalWrapper.tsx + 1 modules
var ModalWrapper = __webpack_require__(38949);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DropOffModal/DropOffModal.style.ts


const HeaderTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "DropOffModalstyle__HeaderTitle",
  componentId: "haqw5h-0"
})(["font-weight:400;font-size:14px;color:", ";"], Global/* theme.greyText */.rS.greyText);
const ModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DropOffModalstyle__ModalBody",
  componentId: "haqw5h-1"
})(["padding:16px 30px 30px;display:flex;flex-direction:column;background:#ffffff;gap:8px;"]);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DropOffModalstyle__BenefitItem",
  componentId: "haqw5h-2"
})(["display:flex;align-items:center;background:#f5f5f5;gap:16px;border-radius:16px;padding:12px;font-weight:400;font-size:14px;"]);
const BenefitIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DropOffModalstyle__BenefitIcon",
  componentId: "haqw5h-3"
})(["img{border-radius:8px;object-fit:contain;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/DropOffModal/DropOffModal.tsx









const DropOffModal = ({
  data,
  isOpen,
  onClose,
  onCTAClick
}) => {
  if (!data) return null;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const bottomsheetId = data?.bottomsheetId || "education";
  (0,react.useEffect)(() => {
    analytics?.trackCommonLandingEvents({
      actionType: `${bottomsheetId}_bottomsheet_seen`
    });
  }, []);
  const ctaText = typeof data?.ctaText?.title?.text === "object" && !Array.isArray(data?.ctaText?.title?.text) ? data.ctaText.title.text.value : "EXPLORE INSURANCE";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapper/* ModalWrapper */.A, {
    isOpen: isOpen,
    onClose: onClose,
    "data-test-id": "DropOffModal-ModalWrapper",
    children: [data?.img && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
      src: data.img,
      width: "500px",
      height: "auto",
      alt: "Travel Safety",
      "data-test-id": "DropOffModal-ImageComponent"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalBody, {
      "data-test-id": "DropOffModal-ModalBody",
      children: [data?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderTitle, {
        "data-test-id": "DropOffModal-HeaderTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.title,
          "data-test-id": "DropOffModal-FormattedText"
        })
      }), data?.list?.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
        "data-test-id": `DropOffModal-BenefitItem-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
          "data-test-id": "DropOffModal-BenefitIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
            src: item.img,
            width: "48px",
            height: "48px",
            alt: `Benefit ${index + 1}`,
            "data-test-id": "DropOffModal-ImageComponent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: item.des,
          "data-test-id": "DropOffModal-FormattedText"
        })]
      }, index)), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
        customTitle: ctaText,
        onClick: () => {
          analytics?.trackCommonLandingEvents({
            actionType: `${bottomsheetId}_primary_cta_clicked`
          });
          onCTAClick?.();
        },
        customWidth: "100%",
        "data-test-id": "DropOffModal-LandingButton"
      })]
    })]
  });
};
/* harmony default export */ const DropOffModal_DropOffModal = (DropOffModal);

/***/ }),

/***/ 63894:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": () => (/* binding */ EditTravllerItem),
/* harmony export */   "Kj": () => (/* binding */ BtnWrap),
/* harmony export */   "OX": () => (/* binding */ GenderTypeItem),
/* harmony export */   "V_": () => (/* binding */ TravllerNum),
/* harmony export */   "vU": () => (/* binding */ EditTravelSheetStyle)
/* harmony export */ });
/* unused harmony exports AccordianCompStyle, TravellerAddShimmer */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const AccordianCompStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__AccordianCompStyle",
  componentId: "sc-1wc3syu-0"
})(["padding:16px 24px;border-bottom:1px solid #e2e2e2;display:flex;flex-direction:column;gap:20px;"]);
const GenderTypeItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__GenderTypeItem",
  componentId: "sc-1wc3syu-1"
})(["background:#ffffff;border:1px solid #e2e2e2;border-radius:6px;padding:5px 12px;cursor:pointer;", ""], p => p.selected && `
    background: var(--tm-accent-bg-color);
    border: 1px solid var(--tm-accent-color);
    border-radius: 6px;
`);
const EditTravelSheetStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__EditTravelSheetStyle",
  componentId: "sc-1wc3syu-2"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;top:0px;z-index:10;background-color:#f2f2f2;overflow-y:scroll;"]);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__BtnWrap",
  componentId: "sc-1wc3syu-3"
})(["background:#fff;padding:8px 16px;position:fixed;bottom:0;left:0;right:0;"]);
const TravllerNum = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__TravllerNum",
  componentId: "sc-1wc3syu-4"
})(["border-radius:18px;background:#f6f6f6;width:20px;height:20px;display:flex;justify-content:center;align-items:center;font-size:12px;font-weight:700;flex-shrink:0;"]);
const EditTravllerItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__EditTravllerItem",
  componentId: "sc-1wc3syu-5"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;background:#fff;"]);
const TravellerAddShimmer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "EditTravellerstyle__TravellerAddShimmer",
  componentId: "sc-1wc3syu-6"
})(["padding:24px 30px;border-top:1px solid #e8e8e8;display:flex;justify-content:space-between;"]);

/***/ }),

/***/ 67678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63955);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var _tm_insurance_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78521);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44928);
/* harmony import */ var _tm_utility__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97427);
/* harmony import */ var _EditTraveller_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63894);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52322);












const minDate = "1970-01-01";
const maxDate = new Date().toISOString().split("T")[0];

const EditTraveller = ({
  index,
  title,
  refId,
  fullName,
  dobValue,
  passportValue,
  genderValue,
  travellerDetails,
  travellerAttributes,
  goBackTxt,
  updateContactTxt,
  handleUpdateDetails,
  handleClose
}) => {
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: editError,
    1: setEditError
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const {
    name,
    dob,
    passport,
    gender
  } = travellerAttributes || {};
  const {
    control,
    formState: {
      errors
    },
    setValue,
    setError,
    handleSubmit
  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useForm */ .cI)({
    defaultValues: {
      name: fullName || "",
      dob: dobValue || "",
      passport: passportValue || "",
      gender: genderValue || ""
    },
    mode: "onTouched"
  });

  const handleGenderChange = value => {
    if (value) {
      setValue("gender", value);
    }
  };

  const handleServerErrors = error => {
    const {
      displaySecondaryError = []
    } = error?.validationError || {};
    displaySecondaryError.map(item => {
      const {
        travellerId
      } = item;

      if (travellerId === refId) {
        const {
          name,
          dob,
          passport
        } = item?.displayError;

        if (name) {
          setError("name", {
            message: name
          });
        }

        if (dob) {
          setError("dob", {
            message: dob
          });
        }

        if (passport) {
          setError("passport", {
            message: passport
          });
        }
      }
    });
  };

  const onSubmit = async formData => {
    try {
      const travellerData = travellerDetails.map((item, i) => {
        const {
          refId,
          name,
          dob,
          passport,
          gender
        } = item;
        return {
          refId,
          FullName: i === index ? formData.name?.trim() : name,
          Dob: i === index ? formData.dob : dob,
          Gender: i === index ? formData.gender : gender,
          PassportNo: i === index ? formData.passport : passport
        };
      });
      const queryParams = new URLSearchParams(window.location.search);
      const bookingId = queryParams.get("bookingId");
      const partner = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getPartnerOnClientSide */ .et)();
      setIsLoading(true);
      const response = await (0,_tm_insurance_api__WEBPACK_IMPORTED_MODULE_4__/* .editInsuranceDetails */ .oe)({
        partner,
        bookingID: bookingId,
        data: travellerData
      });
      const {
        responseStatus
      } = response;

      if (responseStatus === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.RESPONSE_STATUS.SUCCESS) {
        await handleUpdateDetails(formData);
      } else {
        const {
          Error: error
        } = response;

        if (!error) {
          throw new Error("Something went wrong");
        }

        handleServerErrors(error);
      }

      setIsLoading(false);
    } catch (err) {
      console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
        err
      });
      setIsLoading(false);
      const {
        Error,
        error
      } = err?.response?.data;

      if (Error && Error?.code === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.ERROR_CODES.DISPLAY_ERROR) {
        handleServerErrors(Error);
      } else {
        setEditError(error);
      }
    }
  };

  if (editError && true) {
    throw new _tm_utility__WEBPACK_IMPORTED_MODULE_7__/* .ClientError */ .XF(editError);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.CommonModalDweb, {
    customTitle: title,
    handleClick: handleClose,
    "data-test-id": "EditTraveller-CommonModalDweb",
    children: [name?.isEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
      control: control,
      name: "name",
      rules: {
        required: {
          value: name?.isRequired ?? true,
          message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("name")
        },
        pattern: {
          value: new RegExp(name?.regex || ""),
          message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("name", name?.errorMessage)
        }
      },
      render: ({
        field: {
          value,
          onChange,
          onBlur
        }
      }) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingInput, {
        requiredField: name?.isRequired,
        placeholderTxt: name?.placeholder,
        labelTxt: name?.title,
        inputValue: value,
        errorState: errors.name?.message,
        disableState: isLoading,
        handleChange: onChange,
        handleBlur: onBlur,
        inputWidth: "100%",
        margin: "0 0 16px",
        "data-test-id": "EditTraveller-LandingInput"
      }),
      "data-test-id": "EditTraveller-Controller"
    }), dob?.isEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
      control: control,
      name: "dob",
      rules: {
        required: {
          value: dob?.isRequired ?? true,
          message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("dob")
        },
        validate: value => (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .isDobValid */ .qP)(value || "", dob?.regex) || (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("dob", dob?.errorMessage)
      },
      render: ({
        field: {
          value,
          onChange,
          onBlur
        }
      }) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingInput, {
        requiredField: dob?.isRequired,
        placeholderTxt: " ",
        labelTxt: dob?.title,
        inputType: "date",
        inputValue: value,
        minValue: minDate,
        maxValue: maxDate,
        errorState: errors.dob?.message,
        disableState: isLoading,
        handleChange: onChange,
        handleBlur: onBlur,
        inputWidth: "100%",
        margin: "0 0 16px",
        "data-test-id": "EditTraveller-LandingInput"
      }),
      "data-test-id": "EditTraveller-Controller"
    }), passport?.isEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
      control: control,
      name: "passport",
      rules: {
        required: {
          value: passport?.isRequired ?? true,
          message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("passport")
        },
        pattern: {
          value: new RegExp(passport?.regex || ""),
          message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("passport", passport?.errorMessage)
        }
      },
      render: ({
        field: {
          value,
          onChange,
          onBlur
        }
      }) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingInput, {
        requiredField: passport?.isRequired,
        placeholderTxt: passport?.placeholder,
        labelTxt: passport?.title,
        inputValue: value,
        errorState: errors.passport?.message,
        disableState: isLoading,
        handleChange: onChange,
        handleBlur: onBlur,
        inputWidth: "100%",
        margin: "0 0 16px",
        "data-test-id": "EditTraveller-LandingInput"
      }),
      "data-test-id": "EditTraveller-Controller"
    }), gender?.isEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.SpanTag, {
        margin: "0 0 8px",
        fontSize: "md",
        fontWeight: "bold",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText,
        "data-test-id": "EditTraveller-SpanTag",
        children: "Gender"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
        gap: "8px",
        "data-test-id": "EditTraveller-FlexComp",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Qr, {
          control: control,
          name: "gender",
          rules: {
            required: {
              value: gender?.isRequired ?? true,
              message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFormFieldErrorMsg */ .YV)("gender")
            }
          },
          render: ({
            field: {
              value
            }
          }) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
            children: gender?.values?.map((item, index) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_8__/* .GenderTypeItem */ .OX, {
              selected: item.label?.toLowerCase() === value?.toLowerCase(),
              onClick: () => {
                handleGenderChange(item.label);
              },
              "data-test-id": "EditTraveller-GenderTypeItem",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.RadioButton, {
                activeBtn: item.label?.toLowerCase() === value?.toLowerCase(),
                "data-test-id": "EditTraveller-RadioButton",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.SpanTag, {
                  fontSize: "xs",
                  fontWeight: "bold",
                  color: item.label?.toLowerCase() === value?.toLowerCase() ? `var(--tm-accent-color)` : _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText,
                  "data-test-id": "EditTraveller-SpanTag",
                  children: item.label
                })
              })
            }, item.id))
          }),
          "data-test-id": "EditTraveller-Controller"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "32px 0 0",
      gap: "10px",
      "data-test-id": "EditTraveller-FlexComp",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingButton, {
        onClick: handleSubmit(onSubmit),
        customWidth: "210px",
        customTitle: updateContactTxt,
        isLoading: isLoading,
        "data-test-id": "EditTraveller-LandingButton"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.AnchorTag, {
        handleClick: handleClose,
        fontSize: "md",
        fontWeight: "bold",
        textTransform: "uppercase",
        "data-test-id": "EditTraveller-AnchorTag",
        children: goBackTxt
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EditTraveller);

/***/ }),

/***/ 76801:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44928);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42874);
/* harmony import */ var _tm_insurance_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78521);
/* harmony import */ var _EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63894);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52322);










const minDate = "1970-01-01";
const maxDate = new Date().toISOString().split("T")[0];

const EditTravellerSheet = ({
  handleClose,
  travellerData,
  editTraveller,
  updateOrderDetails
}) => {
  const {
    0: editTravller,
    1: setEditTraveller
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    0: isError,
    1: setIsError
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const travellers = travellerData.map((item, i) => {
    const {
      refId,
      name,
      dob,
      passport,
      gender
    } = item;
    return {
      refId,
      FullName: name,
      Dob: dob,
      Gender: gender,
      PassportNo: passport
    };
  });
  const {
    0: travellerDataState,
    1: setTravellerDataState
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([...travellers]);
  const emptyErrorList = travellerData.map(() => {
    return {
      nameError: "",
      dobError: "",
      passportError: ""
    };
  });
  const {
    0: errorMessages,
    1: setErrorMessages
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([...emptyErrorList]);

  const handleEditTravller = index => {
    setEditTraveller(index);
  };

  const handleServerErrors = error => {
    setIsError(true);
    const {
      displaySecondaryError = []
    } = error?.validationError || {};
    displaySecondaryError.map((item, index) => {
      const {
        name,
        dob,
        passport
      } = item?.displayError;

      if (name) {
        let updatedErrorMessages = [...errorMessages];
        updatedErrorMessages[index].nameError = name;
        setErrorMessages(updatedErrorMessages);
        setEditTraveller(index);
      }

      if (dob) {
        let updatedErrorMessages = [...errorMessages];
        updatedErrorMessages[index].dobError = dob;
        setErrorMessages(updatedErrorMessages);
        setEditTraveller(index);
      }

      if (passport) {
        let updatedErrorMessages = [...errorMessages];
        updatedErrorMessages[index].passportError = passport;
        setErrorMessages(updatedErrorMessages);
        setEditTraveller(index);
      }
    });
  };

  const onSubmit = async () => {
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const bookingId = queryParams.get("bookingId");
      const partner = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .getPartnerOnClientSide */ .et)();
      setIsLoading(true);
      const response = await (0,_tm_insurance_api__WEBPACK_IMPORTED_MODULE_5__/* .editInsuranceDetails */ .oe)({
        partner,
        bookingID: bookingId,
        data: travellerDataState
      });
      const {
        responseStatus
      } = response;

      if (responseStatus === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.RESPONSE_STATUS.SUCCESS) {
        await updateOrderDetails?.();
      } else {
        const {
          Error: error
        } = response;

        if (!error) {
          throw new Error("Something went wrong");
        }

        handleServerErrors(error);
      }

      setEditTraveller(-1);
    } catch (err) {
      console.log("ERROR IN UPDATING TRAVELLER DETAILS----", {
        err
      });
      const {
        Error
      } = err?.response?.data;

      if (Error && Error?.code === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.ERROR_CODES.DISPLAY_ERROR) {
        handleServerErrors(Error);
      }
    }

    setIsLoading(false);
  };

  const onNameChange = (updatedName, index) => {
    const updatedTravellerDataState = [...travellerDataState];
    updatedTravellerDataState[index].FullName = updatedName;
    setTravellerDataState(updatedTravellerDataState);
    validateName(updatedName, index);
  };

  const validateName = (updatedName, index) => {
    const isNameValid = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isFieldValid */ .K0)(editTraveller?.travellerAttributes?.name?.regex ?? "", updatedName);

    if (!isNameValid) {
      setIsError(true);
      let updatedErrorMessages = [...errorMessages];
      updatedErrorMessages[index].nameError = editTraveller?.travellerAttributes?.name?.errorMessage ?? "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages([...emptyErrorList]);
    }
  };

  const onPassportChange = (updatedPassport, index) => {
    const updatedTravellerDataState = [...travellerDataState];
    updatedTravellerDataState[index].PassportNo = updatedPassport?.trim?.();
    setTravellerDataState(updatedTravellerDataState);
    validatePassport(updatedPassport, index);
  };

  const validatePassport = (updatedPassport, index) => {
    const isPassportValid = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isFieldValid */ .K0)(editTraveller?.travellerAttributes?.passport?.regex ?? "", updatedPassport);

    if (!isPassportValid) {
      setIsError(true);
      let updatedErrorMessages = [...errorMessages];
      updatedErrorMessages[index].passportError = editTraveller?.travellerAttributes?.passport?.errorMessage ?? "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages([...emptyErrorList]);
    }
  };

  const onDobChange = (updatedDob, index) => {
    const updatedTravellerDataState = [...travellerDataState];
    updatedTravellerDataState[index].Dob = updatedDob?.trim?.();
    setTravellerDataState(updatedTravellerDataState);
    validateDob(updatedDob, index);
  };

  const validateDob = (updatedDob, index) => {
    const isDobValid = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .isFieldValid */ .K0)(editTraveller?.travellerAttributes?.dob?.regex ?? "", (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .p6)(updatedDob, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.DATE_FORMATS["DD/MM/YYYY"]));

    if (!isDobValid) {
      setIsError(true);
      let updatedErrorMessages = [...errorMessages];
      updatedErrorMessages[index].dobError = editTraveller?.travellerAttributes?.dob?.errorMessage ?? "";
      setErrorMessages(updatedErrorMessages);
    } else {
      setIsError(false);
      setErrorMessages([...emptyErrorList]);
    }
  };

  const onGenderChange = (updatedGender, index) => {
    const updatedTravellerDataState = [...travellerDataState];
    updatedTravellerDataState[index].Gender = updatedGender?.trim?.();
    setTravellerDataState(updatedTravellerDataState);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ReactPortalComp, {
    "data-test-id": "EditTravellerSheet-ReactPortalComp",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__/* .EditTravelSheetStyle */ .vU, {
      "data-test-id": "EditTravellerSheet-EditTravelSheetStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingHeaderMobile, {
        displayWhiteHeader: true,
        headerTitle: "Edit Traveller Details",
        handleBackBtn: handleClose,
        "data-test-id": "EditTravellerSheet-LandingHeaderMobile"
      }), travellerDataState?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__/* .EditTravllerItem */ .AR, {
            "data-test-id": `EditTravellerSheet-EditTravllerItem-${index}`,
            children: [editTravller != index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
              justifyContent: "space-between",
              "data-test-id": "EditTravellerSheet-FlexComp",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
                gap: "10px",
                "data-test-id": "EditTravellerSheet-FlexComp",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__/* .TravllerNum */ .V_, {
                  "data-test-id": "EditTravellerSheet-TravllerNum",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                    value: `${index + 1}`,
                    "data-test-id": "EditTravellerSheet-FormattedText"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
                    fontWeight: "bold",
                    "data-test-id": "EditTravellerSheet-ParaTag",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                      value: item.FullName,
                      "data-test-id": "EditTravellerSheet-FormattedText"
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
                      fontSize: "xs",
                      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
                      "data-test-id": "EditTravellerSheet-SpanTag",
                      children: item?.Dob && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                        value: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .p6)(item.Dob, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.DATE_FORMATS["DD/MM/YYYY"]),
                        "data-test-id": "EditTravellerSheet-FormattedText"
                      })
                    }), "\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
                      fontSize: "xs",
                      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
                      "data-test-id": "EditTravellerSheet-SpanTag",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                        value: item.Gender,
                        "data-test-id": "EditTravellerSheet-FormattedText"
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.AnchorTag, {
                textTransform: "uppercase",
                fontSize: "xs",
                fontWeight: "bold",
                handleClick: () => handleEditTravller(index),
                "data-test-id": "EditTravellerSheet-AnchorTag",
                children: "Edit"
              })]
            }), editTravller == index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
                margin: "0 0 18px",
                fontWeight: "bold",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
                "data-test-id": "EditTravellerSheet-ParaTag",
                children: ["Traveller ", index + 1]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingInput, {
                flex: "1",
                requiredField: true,
                placeholderTxt: "FULL NAME",
                labelTxt: "FULL NAME",
                inputValue: item.FullName,
                errorState: errorMessages?.[index]?.nameError // disableState={isLoading}
                ,
                handleChange: event => onNameChange(event.target.value, index),
                handleBlur: event => {
                  validateName(event.target.value, index);
                },
                autoComplete: "off",
                margin: "0 0 8px",
                "data-test-id": "EditTravellerSheet-LandingInput"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingInput, {
                flex: "1",
                placeholderTxt: "Date of birth",
                requiredField: true,
                labelTxt: "Date of birth",
                inputType: "date",
                inputValue: item.Dob,
                minValue: minDate,
                maxValue: maxDate,
                errorState: errorMessages?.[index]?.dobError // disableState={isLoading}
                ,
                handleChange: event => {
                  onDobChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: event => {
                  validateDob(event.target.value, index);
                },
                margin: "0 0 8px",
                "data-test-id": "EditTravellerSheet-LandingInput"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
                margin: "0 0 8px",
                fontSize: "md",
                fontWeight: "bold",
                color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
                "data-test-id": "EditTravellerSheet-SpanTag",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
                  value: "Gender",
                  "data-test-id": "EditTravellerSheet-FormattedText"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
                gap: "8px",
                margin: "0 0 10px",
                "data-test-id": "EditTravellerSheet-FlexComp",
                children: editTraveller?.travellerAttributes?.gender?.values?.map(gender => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__/* .GenderTypeItem */ .OX, {
                  selected: gender.label?.toLowerCase() == item.Gender?.toLowerCase(),
                  onClick: () => {
                    onGenderChange(gender.label, index); // saveFormValuesOnBlur();
                  },
                  "data-test-id": "EditTravellerSheet-GenderTypeItem",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.RadioButton, {
                    activeBtn: gender.label?.toLowerCase() == item.Gender?.toLowerCase(),
                    "data-test-id": "EditTravellerSheet-RadioButton",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
                      fontSize: "xs",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      color: gender.label?.toLowerCase() == item.Gender?.toLowerCase() ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.blueText */ .rS.blueText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_4__/* .theme.greyText */ .rS.greyText,
                      "data-test-id": "EditTravellerSheet-SpanTag",
                      children: gender.label
                    })
                  })
                }, gender.id))
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingInput, {
                flex: "1",
                placeholderTxt: "PASSPORT NO.",
                labelTxt: "PASSPORT NO.",
                inputValue: item.PassportNo,
                errorState: errorMessages?.[index]?.passportError // disableState={isLoading}
                ,
                handleChange: event => {
                  onPassportChange(event.target.value, index); // saveFormValuesOnBlur();
                },
                handleBlur: event => {
                  validatePassport(event.target.value, index);
                },
                "data-test-id": "EditTravellerSheet-LandingInput"
              })]
            })]
          }, index)
        });
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_EditTraveller_style__WEBPACK_IMPORTED_MODULE_6__/* .BtnWrap */ .Kj, {
        "data-test-id": "EditTravellerSheet-BtnWrap",
        children: editTravller >= 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.LandingButton, {
          customTitle: editTraveller?.updateNowBtnTxt,
          customWidth: "100%",
          onClick: onSubmit,
          isLoading: isLoading,
          disableState: isError,
          "data-test-id": "EditTravellerSheet-LandingButton"
        })
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EditTravellerSheet);

/***/ }),

/***/ 9840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ EducationModal_EducationModal)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx
var LandingButton = __webpack_require__(99660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationHighlights.tsx + 1 modules
var EducationHighlights = __webpack_require__(44808);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationProcess.tsx + 1 modules
var EducationProcess = __webpack_require__(29462);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EducationModal/EducationModal.style.ts

const ModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__ModalOverlay",
  componentId: "sc-75wua7-0"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9999;display:flex;align-items:center;justify-content:center;", " background:rgba(0,0,0,0.5);"], p => p.fullscreen && `padding: 0;`);
const ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__ModalContent",
  componentId: "sc-75wua7-1"
})(["background:#fff;border-radius:16px;width:", ";height:", ";max-width:100vw;max-height:100vh;overflow-y:auto;position:relative;", ""], p => p.fullscreen ? "100vw" : "450px", p => p.fullscreen ? "100vh" : "auto", p => p.fullscreen && `border-radius: 0;`);
const Stepper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__Stepper",
  componentId: "sc-75wua7-2"
})(["display:flex;justify-content:center;align-items:center;margin:16px 0 12px 0;gap:6px;"]);
const StepDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__StepDot",
  componentId: "sc-75wua7-3"
})(["width:", ";height:8px;border-radius:4px;background:", ";transition:width 0.2s;"], p => p.active ? "32px" : "8px", p => p.active ? "#666" : "#E0E0E0");
const StickyFooterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__StickyFooterSection",
  componentId: "sc-75wua7-4"
})(["", ""], ({
  $isDesktop
}) => $isDesktop && `
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      box-shadow: 0 -2px 12px rgba(0,0,0,0.08);
      z-index: 10;
    `);
const ButtonRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationModalstyle__ButtonRow",
  componentId: "sc-75wua7-5"
})(["display:flex;justify-content:space-between;align-items:center;margin-top:16px;padding:16px;"]);
const KnowMoreLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "EducationModalstyle__KnowMoreLink",
  componentId: "sc-75wua7-6"
})(["display:block;text-align:center;color:#008cff;font-weight:600;font-size:16px;margin:16px 0 0 0;text-decoration:none;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/EducationModal/EducationModal.tsx














const EducationModal = ({
  pagesData,
  knowMore,
  setShowEducationModal,
  skipButtonHandler,
  onModalShown,
  onNextClick,
  onSkipClick,
  onPageShown
}) => {
  if (!pagesData) return null;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const device = (0,src/* useBreakpointV2 */.bU)();
  const fullscreen = device === "sm";
  const [page, setPage] = react.useState(0); // Track modal shown on mount

  react.useEffect(() => {
    onModalShown && onModalShown();
  }, []); // Track page shown on page change

  react.useEffect(() => {
    if (pagesData && pagesData[page] && onPageShown) {
      onPageShown(pagesData[page].pageID);
    }
  }, [page, pagesData, onPageShown]); // Sticky footer only if content is overflowing and device is desktop

  const modalContentRef = (0,react.useRef)(null);
  const {
    0: isOverflowing,
    1: setIsOverflowing
  } = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    function checkOverflow() {
      const el = modalContentRef.current;

      if (el) {
        setIsOverflowing(el.scrollHeight > el.clientHeight);
      }
    }

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [pagesData, page, device]);

  const BackArrow = ({
    color = Global/* theme.greyText6 */.rS.greyText6,
    width = 24,
    height = 24,
    className,
    onClick
  }) => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick,
    style: {
      cursor: onClick ? "pointer" : "default",
      marginRight: "16px"
    },
    viewBox: "0 0 24 24",
    "data-test-id": "EducationModal-BackArrow",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m12 20-8-8 8-8 1.425 1.4-5.6 5.6H20v2H7.825l5.6 5.6L12 20Z",
      fill: color
    })
  });

  (0,react.useEffect)(() => {
    if ( false || typeof document === "undefined") return;

    if (device === "lg") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }

    return;
  }, [device]);

  const handleNext = () => {
    onNextClick && onNextClick();

    if (page < pagesData.length - 1) {
      setPage(page + 1);
    } else {
      skipButtonHandler();
    }
  };

  const handleSkip = () => {
    onSkipClick && onSkipClick();
    skipButtonHandler();
  };

  const currentPage = pagesData[page];
  let ModalContentComponent = null;

  if (currentPage?.pageID === "HOW_IT_WORKS" || currentPage?.pageID === "PROCESS_STEPS") {
    ModalContentComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(EducationProcess/* default */.Z, {
      backendData: currentPage,
      "data-test-id": "EducationModal-EducationProcess"
    });
  } else if (currentPage?.pageID === "HIGHLIGHTS") {
    ModalContentComponent = /*#__PURE__*/(0,jsx_runtime.jsx)(EducationHighlights/* default */.Z, {
      backendData: currentPage,
      "data-test-id": "EducationModal-EducationHighlights"
    });
  }

  return /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)(ModalOverlay, {
    fullscreen: fullscreen,
    onClick: () => setShowEducationModal(false),
    "data-test-id": "EducationModal-ModalOverlay",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalContent, {
      ref: modalContentRef,
      fullscreen: fullscreen,
      onClick: e => e.stopPropagation(),
      "data-test-id": "EducationModal-ModalContent",
      children: [device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp/* default */.Z, {
        justifyContent: "flex-start",
        alignItems: "center",
        margin: "0 0 16px 0",
        "data-test-id": "EducationModal-FlexComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackArrow, {
          color: Global/* theme.greyText6 */.rS.greyText6,
          onClick: () => setShowEducationModal(false),
          "data-test-id": "EducationModal-BackArrow"
        })
      }), ModalContentComponent, /*#__PURE__*/(0,jsx_runtime.jsxs)(StickyFooterSection, {
        $isDesktop: device === "lg" && isOverflowing,
        "data-test-id": "EducationModal-StickyFooterSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(KnowMoreLink, {
          href: knowMore?.url,
          target: "_blank",
          rel: "noopener noreferrer",
          "data-test-id": "EducationModal-KnowMoreLink",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: knowMore?.title,
            "data-test-id": "EducationModal-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Stepper, {
          "data-test-id": "EducationModal-Stepper",
          children: pagesData.map((_, idx) => /*#__PURE__*/(0,jsx_runtime.jsx)(StepDot, {
            active: idx === page,
            "data-test-id": `EducationModal-StepDot-${idx}`
          }, idx))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonRow, {
          "data-test-id": "EducationModal-ButtonRow",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
            customTitle: "SKIP",
            onClick: handleSkip,
            padding: "0px 40px",
            customWidth: "49%",
            "data-test-id": "EducationModal-LandingButton"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
            customTitle: "NEXT",
            onClick: handleNext,
            padding: "0px 40px",
            customWidth: "49%",
            "data-test-id": "EducationModal-LandingButton"
          })]
        })]
      })]
    })
  }), document.body);
};

/* harmony default export */ const EducationModal_EducationModal = (EducationModal);

/***/ }),

/***/ 98276:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IK": () => (/* binding */ GENDER_VALUE_MAPPING),
/* harmony export */   "nY": () => (/* binding */ ExcelUploadError),
/* harmony export */   "rW": () => (/* binding */ ExcelUploadErrorCode),
/* harmony export */   "wS": () => (/* binding */ HEADER_MAPPING)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);

// Error codes for Excel upload operations
let ExcelUploadErrorCode; // Custom error class with code support

(function (ExcelUploadErrorCode) {
  ExcelUploadErrorCode["FILE_SIZE_EXCEEDED"] = "FILE_SIZE_EXCEEDED";
  ExcelUploadErrorCode["UNSUPPORTED_FILE_TYPE"] = "UNSUPPORTED_FILE_TYPE";
  ExcelUploadErrorCode["UNABLE_TO_READ_FILE"] = "UNABLE_TO_READ_FILE";
  ExcelUploadErrorCode["NO_DETAILS_FOUND"] = "NO_DETAILS_FOUND";
  ExcelUploadErrorCode["FIELDS_MISSING"] = "FIELDS_MISSING";
  ExcelUploadErrorCode["TOO_MANY_ROWS"] = "TOO_MANY_ROWS";
  ExcelUploadErrorCode["FILE_FORMAT_ERROR"] = "FILE_FORMAT_ERROR";
  ExcelUploadErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(ExcelUploadErrorCode || (ExcelUploadErrorCode = {}));

class ExcelUploadError extends Error {
  constructor(code, message, missingFields) {
    super(message || code);

    (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "code", void 0);

    (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "missingFields", void 0);

    this.code = code;
    this.missingFields = missingFields;
    this.name = "ExcelUploadError";
  }

} // Expected column headers mapping (case-insensitive)

const HEADER_MAPPING = {
  name: "name",
  "date of birth (dd/mm/yyyy)": "dob",
  "date of birth": "dob",
  dob: "dob",
  gender: "gender",
  "gender (m/f/o)": "gender",
  "gender (male/female/others)": "gender",
  "passport number": "passport",
  "passport number (optional)": "passport",
  "nominee name": "nomineeName",
  nominee: "nomineeName",
  "nominee name (optional)": "nomineeName",
  "nominee (optional)": "nomineeName"
}; // Gender value mapping (case-insensitive) - maps various inputs to standard values

const GENDER_VALUE_MAPPING = {
  m: "MALE",
  male: "MALE",
  f: "FEMALE",
  female: "FEMALE",
  o: "OTHERS",
  others: "OTHERS",
  other: "OTHERS"
};

/***/ }),

/***/ 87080:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ ExcelUpload_ExcelUpload)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(2638);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/ErrorIcon.tsx
var ErrorIcon = __webpack_require__(44567);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/FileIcon.tsx
var FileIcon = __webpack_require__(8161);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/UploadIcon.tsx
var UploadIcon = __webpack_require__(97379);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/xlsx/xlsx.mjs
var xlsx = __webpack_require__(66768);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/ExcelUpload.constants.ts
var ExcelUpload_constants = __webpack_require__(98276);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/ExcelUpload.style.ts


const pulse = (0,styled_components_browser_esm/* keyframes */.F4)(["0%,100%{opacity:1;}50%{opacity:0.7;}"]);
const slideIn = (0,styled_components_browser_esm/* keyframes */.F4)(["from{opacity:0;transform:translateY(-10px);}to{opacity:1;transform:translateY(0);}"]);
const ExcelUploadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__ExcelUploadWrapper",
  componentId: "hhl0to-0"
})(["display:flex;flex-direction:column;gap:12px;width:100%;"]);
const UploadRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__UploadRow",
  componentId: "hhl0to-1"
})(["display:flex;align-items:center;gap:12px;"]);
const HiddenInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ExcelUploadstyle__HiddenInput",
  componentId: "hhl0to-2"
})(["display:none;"]);
const UploadButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ExcelUploadstyle__UploadButton",
  componentId: "hhl0to-3"
})(["display:flex;align-items:center;justify-content:center;gap:8px;width:200px;padding:9px;border-radius:8px;border:none;background:", ";color:", ";font-size:14px;font-weight:600;cursor:", ";transition:all 0.2s ease;height:32px;&:hover:not(:disabled){background:#0070cc;transform:translateY(-1px);box-shadow:0 4px 12px rgba(0,140,255,0.25);}&:active:not(:disabled){transform:translateY(0);}", ""], ({
  disabled
}) => disabled ? Global/* theme.lightGreyText */.rS.lightGreyText : Global/* theme.blueText */.rS.blueText, Global/* theme.whiteText */.rS.whiteText, ({
  disabled
}) => disabled ? "not-allowed" : "pointer", ({
  isLoading
}) => isLoading && (0,styled_components_browser_esm/* css */.iv)(["animation:", " 1.5s ease-in-out infinite;pointer-events:none;"], pulse));
const FileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__FileInfo",
  componentId: "hhl0to-4"
})(["display:flex;align-items:center;justify-content:space-between;padding:0 10px;height:32px;background:#f3f4f6;border-radius:6px;animation:", " 0.3s ease;max-width:300px;"], slideIn);
const FileDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__FileDetails",
  componentId: "hhl0to-5"
})(["display:flex;align-items:center;gap:8px;"]);
const ExcelUpload_style_FileIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__FileIcon",
  componentId: "hhl0to-6"
})(["width:20px;height:20px;border-radius:4px;background:", ";display:flex;align-items:center;justify-content:center;svg{color:", ";width:12px;height:12px;}"], Global/* theme.greenText */.rS.greenText, Global/* theme.whiteText */.rS.whiteText);
const FileName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ExcelUploadstyle__FileName",
  componentId: "hhl0to-7"
})(["font-size:12px;font-weight:600;color:", ";margin:0;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], Global/* theme.blackText */.rS.blackText);
const FileSize = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExcelUploadstyle__FileSize",
  componentId: "hhl0to-8"
})(["font-size:11px;color:", ";"], Global/* theme.greyText */.rS.greyText);
const RemoveButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ExcelUploadstyle__RemoveButton",
  componentId: "hhl0to-9"
})(["padding:4px;border:none;background:transparent;cursor:pointer;border-radius:4px;display:flex;align-items:center;justify-content:center;color:", ";transition:all 0.2s ease;svg{width:14px;height:14px;}&:hover{background:", ";color:", ";}"], Global/* theme.greyText */.rS.greyText, Global/* theme.darkGreyBg */.rS.darkGreyBg, Global/* theme.redText */.rS.redText);
const ErrorMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__ErrorMessage",
  componentId: "hhl0to-10"
})(["display:flex;align-items:center;gap:6px;svg{flex-shrink:0;}span{font-size:12px;color:", ";}"], Global/* theme.redText */.rS.redText);
const LoadingSpinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExcelUploadstyle__LoadingSpinner",
  componentId: "hhl0to-11"
})(["width:16px;height:16px;border:2px solid ", ";border-top-color:transparent;border-radius:50%;animation:spin 0.8s linear infinite;@keyframes spin{to{transform:rotate(360deg);}}"], Global/* theme.whiteText */.rS.whiteText);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/ExcelUpload.utils.ts
const formatFileSize = bytes => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
/**
 * Parse various date formats to yyyy-mm-dd
 * Handles all Excel-supported date formats:
 * - Excel serial numbers (days since 1900-01-01)
 * - DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY (European formats)
 * - MM/DD/YYYY, MM-DD-YYYY, MM.DD.YYYY (US formats)
 * - YYYY-MM-DD, YYYY/MM/DD, YYYY.MM.DD (ISO formats)
 * - DD/MM/YY, MM/DD/YY, YY/MM/DD (2-digit year formats)
 * - YYYYMMDD (compact format)
 * - "January 15, 1990", "15 Jan 1990", "Jan 15, 1990" (text formats)
 */

const parseDateToYYYYMMDD = dateValue => {
  if (!dateValue) return ""; // If it's already in yyyy-mm-dd format, return as is

  if (typeof dateValue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
    return dateValue;
  } // Handle Excel serial number (number of days since 1900-01-01)


  if (typeof dateValue === "number") {
    // Excel dates are number of days since 1900-01-01 (with a bug for 1900 leap year)
    const excelEpoch = new Date(1899, 11, 30); // Dec 30, 1899

    const date = new Date(excelEpoch.getTime() + dateValue * 24 * 60 * 60 * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const dateStr = String(dateValue).trim(); // Helper to format date consistently

  const formatDate = (y, m, d) => {
    const year = String(y).padStart(4, "0");
    const month = String(m).padStart(2, "0");
    const day = String(d).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }; // Helper to expand 2-digit year (assumes 00-29 = 2000s, 30-99 = 1900s)


  const expandYear = yy => {
    return yy < 30 ? 2000 + yy : 1900 + yy;
  }; // Try parsing common date formats


  let parsedDate = null; // Format: YYYYMMDD (compact, no separators)

  const compactYYYYMMDD = dateStr.match(/^(\d{4})(\d{2})(\d{2})$/);

  if (compactYYYYMMDD) {
    const [, year, month, day] = compactYYYYMMDD;
    return formatDate(parseInt(year), parseInt(month), parseInt(day));
  } // Format: YYYY/MM/DD, YYYY-MM-DD, or YYYY.MM.DD (ISO format - highest priority)


  const yyyymmdd = dateStr.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})$/);

  if (yyyymmdd) {
    const [, year, month, day] = yyyymmdd;
    parsedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  } // Format: DD/MM/YYYY, DD-MM-YYYY, or DD.MM.YYYY (European format)


  if (!parsedDate) {
    const ddmmyyyy = dateStr.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/);

    if (ddmmyyyy) {
      const [, day, month, year] = ddmmyyyy;
      const monthNum = parseInt(month);
      const dayNum = parseInt(day); // Only use European format if month is valid (1-12) and day > 12 (disambiguates from US format)
      // If both could be valid months, prefer European format

      if (monthNum >= 1 && monthNum <= 12 && dayNum <= 31) {
        parsedDate = new Date(parseInt(year), monthNum - 1, dayNum);
      }
    }
  } // Format: DD/MM/YY, DD-MM-YY, or DD.MM.YY (2-digit year European format)


  if (!parsedDate) {
    const ddmmyy = dateStr.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{2})$/);

    if (ddmmyy) {
      const [, day, month, yy] = ddmmyy;
      const year = expandYear(parseInt(yy));
      parsedDate = new Date(year, parseInt(month) - 1, parseInt(day));
    }
  } // Format: YY/MM/DD, YY-MM-DD, or YY.MM.DD (2-digit year ISO-like format)


  if (!parsedDate) {
    const yymmdd = dateStr.match(/^(\d{2})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})$/);

    if (yymmdd) {
      const [, yy, month, day] = yymmdd;
      const yearNum = parseInt(yy); // If yy > 31, it's likely a year, not a day

      if (yearNum > 31) {
        const year = expandYear(yearNum);
        parsedDate = new Date(year, parseInt(month) - 1, parseInt(day));
      }
    }
  } // Format: MM/DD/YYYY (US format) - try if first number is valid month and second is valid day


  if (!parsedDate) {
    const mmddyyyy = dateStr.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/);

    if (mmddyyyy) {
      const [, first, second, year] = mmddyyyy;
      const monthNum = parseInt(first);
      const dayNum = parseInt(second); // Use US format if first is valid month (1-12) and second is valid day (1-31)

      if (monthNum >= 1 && monthNum <= 12 && dayNum >= 1 && dayNum <= 31) {
        parsedDate = new Date(parseInt(year), monthNum - 1, dayNum);
      }
    }
  } // Try native Date parsing for text formats like:
  // "January 15, 1990", "15 Jan 1990", "Jan 15, 1990", "15-Jan-1990", etc.


  if (!parsedDate) {
    const nativeDate = new Date(dateStr);

    if (!isNaN(nativeDate.getTime())) {
      parsedDate = nativeDate;
    }
  } // If we successfully parsed the date, format it


  if (parsedDate && !isNaN(parsedDate.getTime())) {
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } // Return original value if parsing failed


  return dateStr;
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/utils/checkout.ts
var checkout = __webpack_require__(38418);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/utils/uploadTemplate.ts
var uploadTemplate = __webpack_require__(71870);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/utils/useUploadTemplate.ts


const useUploadTemplate = (quoteId, itineraryId, isExcelBypass) => {
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: error,
    1: setError
  } = (0,react.useState)(null);
  const {
    0: data,
    1: setData
  } = (0,react.useState)(null);
  const {
    0: isSuccess,
    1: setIsSuccess
  } = (0,react.useState)(false);
  const reset = (0,react.useCallback)(() => {
    setIsLoading(false);
    setError(null);
    setData(null);
    setIsSuccess(false);
  }, []);
  const upload = (0,react.useCallback)(async file => {
    setIsLoading(true);
    setError(null);
    setData(null);
    setIsSuccess(false);

    try {
      const response = await (0,uploadTemplate/* uploadTemplate */.H)(file, quoteId, itineraryId, isExcelBypass);
      setData(response);
      setIsSuccess(true);
      return response;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to upload template";
      setError(errorMessage);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);
  return {
    isLoading,
    error,
    data,
    isSuccess,
    upload,
    reset
  };
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/utils/index.ts



// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExcelUpload/ExcelUpload.tsx















const ExcelUpload = ({
  onDataParsed,
  onError,
  isExcelBypass = false,
  maxFileSizeMB = 5,
  maxRows = 100,
  buttonText = "Upload Excel",
  hideError = false,
  disabled = false,
  className,
  requiredFields,
  errorMessages,
  quoteId = "",
  itineraryId = ""
}) => {
  const {
    0: file,
    1: setFile
  } = (0,react.useState)(null);
  const {
    0: localError,
    1: setLocalError
  } = (0,react.useState)("");
  const {
    0: isLocalLoading,
    1: setIsLocalLoading
  } = (0,react.useState)(false);
  const inputRef = (0,react.useRef)(null);
  const REQUIRED_FIELDS = requiredFields;
  const analytics = (0,insurance/* getAnalytics */.I)(); // Hook for upload API call

  const {
    isLoading: isUploadLoading,
    error: uploadError,
    upload: uploadToServer
  } = useUploadTemplate(quoteId, itineraryId, isExcelBypass); // Combined loading and error states

  const isLoading = isLocalLoading || isUploadLoading;
  const error = localError || uploadError || ""; // Common file validation

  const validateFile = (0,react.useCallback)(selectedFile => {
    // Validate file size
    const maxSizeBytes = maxFileSizeMB * 1024 * 1024;

    if (selectedFile.size > maxSizeBytes) {
      return new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.FILE_SIZE_EXCEEDED */.rW.FILE_SIZE_EXCEEDED);
    } // Validate file type


    const validTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", "application/x-ms-excel"];
    const validExtensions = [".xlsx", ".xls"];
    const fileExtension = selectedFile.name.toLowerCase().slice(selectedFile.name.lastIndexOf("."));

    if (!validTypes.includes(selectedFile.type) && !validExtensions.includes(fileExtension)) {
      return new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.UNSUPPORTED_FILE_TYPE */.rW.UNSUPPORTED_FILE_TYPE);
    }

    return null;
  }, [maxFileSizeMB]);
  const validateHeaders = (0,react.useCallback)(headers => {
    const headerMap = new Map();
    const foundFields = new Set();
    headers.forEach((header, index) => {
      const normalizedHeader = header?.toLowerCase().trim() || "";
      const mappedField = ExcelUpload_constants/* HEADER_MAPPING */.wS[normalizedHeader];

      if (mappedField && !foundFields.has(mappedField)) {
        headerMap.set(index, mappedField);
        foundFields.add(mappedField);
      }
    }); // Check if all required fields are present

    const missingFields = REQUIRED_FIELDS?.filter(field => !foundFields.has(field)) || [];
    return {
      headerMap,
      missingFields
    };
  }, [REQUIRED_FIELDS]); // Upload file directly to server (bypass mode)

  const uploadFileToServer = (0,react.useCallback)(async selectedFile => {
    setIsLocalLoading(true);
    setLocalError("");

    try {
      // Validate file
      const validationError = validateFile(selectedFile);

      if (validationError) {
        throw validationError;
      } // Validate headers before uploading


      const arrayBuffer = await selectedFile.arrayBuffer();
      const workbook = xlsx/* read */.ij(arrayBuffer, {
        type: "array"
      });
      const firstSheetName = workbook.SheetNames[0];

      if (!firstSheetName) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.UNABLE_TO_READ_FILE */.rW.UNABLE_TO_READ_FILE);
      }

      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = xlsx/* utils.sheet_to_json */.P6.sheet_to_json(worksheet, {
        header: 1
      });

      if (jsonData.length < 2) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.NO_DETAILS_FOUND */.rW.NO_DETAILS_FOUND);
      } // Parse and validate headers


      const headers = jsonData[0];
      const {
        missingFields
      } = validateHeaders(headers);

      if (missingFields.length > 0) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.FIELDS_MISSING */.rW.FIELDS_MISSING, undefined, missingFields);
      }

      setIsLocalLoading(false); // Use the hook to upload the file

      const responseData = await uploadToServer(selectedFile);

      if (responseData) {
        setFile(selectedFile); // Route to payment link if it exists

        if (responseData.data?.checkoutUrl) {
          window.location.href = responseData.data.checkoutUrl;
          return;
        }
      }
    } catch (err) {
      if (err instanceof ExcelUpload_constants/* ExcelUploadError */.nY) {
        onError?.(err.code, err.missingFields); // Track excel error analytics

        analytics?.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: `excel | ${err.message}`
        });
      } else {
        const errorMessage = err instanceof Error ? err.message : "Failed to upload Excel file";
        setLocalError(errorMessage);
        onError?.(ExcelUpload_constants/* ExcelUploadErrorCode.UNKNOWN_ERROR */.rW.UNKNOWN_ERROR); // Track excel error analytics

        analytics?.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: `excel | ${errorMessage}`
        });
      }

      setIsLocalLoading(false);
    }
  }, [validateFile, validateHeaders, onError, uploadToServer, analytics]); // Parse Excel file locally

  const parseExcelFile = (0,react.useCallback)(async selectedFile => {
    setIsLocalLoading(true);
    setLocalError("");

    try {
      // Validate file
      const validationError = validateFile(selectedFile);

      if (validationError) {
        throw validationError;
      } // Read file


      const arrayBuffer = await selectedFile.arrayBuffer();
      const workbook = xlsx/* read */.ij(arrayBuffer, {
        type: "array"
      }); // Get first sheet

      const firstSheetName = workbook.SheetNames[0];

      if (!firstSheetName) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.UNABLE_TO_READ_FILE */.rW.UNABLE_TO_READ_FILE);
      }

      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = xlsx/* utils.sheet_to_json */.P6.sheet_to_json(worksheet, {
        header: 1
      });

      if (jsonData.length < 2) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.NO_DETAILS_FOUND */.rW.NO_DETAILS_FOUND);
      } // Parse headers from first row


      const headers = jsonData[0];
      const {
        headerMap,
        missingFields
      } = validateHeaders(headers);

      if (missingFields.length > 0) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.FIELDS_MISSING */.rW.FIELDS_MISSING, undefined, missingFields);
      } // Parse data rows


      const dataRows = jsonData.slice(1);

      if (dataRows.length > maxRows) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.TOO_MANY_ROWS */.rW.TOO_MANY_ROWS);
      }

      const result = [];
      dataRows.forEach((row, rowIndex) => {
        // Skip completely empty rows
        if (!row || row.length === 0 || row.every(cell => !cell)) {
          return;
        }

        const rowData = {};
        let hasAnyData = false;
        headerMap.forEach((field, columnIndex) => {
          const cellValue = row[columnIndex];

          if (field === "dob") {
            // Parse DOB to yyyy-mm-dd format
            const parsedDob = parseDateToYYYYMMDD(cellValue);
            rowData[field] = parsedDob;
            if (parsedDob) hasAnyData = true;
          } else if (field === "gender") {
            // Normalize gender values (m/f/o, male/female/others -> MALE/FEMALE/OTHERS)
            const trimmedValue = cellValue !== undefined && cellValue !== null ? String(cellValue).trim().toLowerCase() : "";
            const normalizedGender = ExcelUpload_constants/* GENDER_VALUE_MAPPING */.IK[trimmedValue] || trimmedValue.toUpperCase();
            rowData[field] = normalizedGender;
            if (normalizedGender) hasAnyData = true;
          } else {
            const trimmedValue = cellValue !== undefined && cellValue !== null ? String(cellValue).trim() : "";
            rowData[field] = trimmedValue;
            if (trimmedValue) hasAnyData = true;
          }
        }); // Only add rows that have at least some data
        // Allow partial data - fields can be empty and will be filled by user

        if (hasAnyData) {
          result.push(rowData);
        }
      });

      if (result.length === 0) {
        throw new ExcelUpload_constants/* ExcelUploadError */.nY(ExcelUpload_constants/* ExcelUploadErrorCode.NO_DETAILS_FOUND */.rW.NO_DETAILS_FOUND);
      } // Deduplicate users based on passport number (keep first occurrence)
      // Empty passport numbers are allowed to have duplicates


      const seenPassports = new Set();
      let duplicatesRemoved = 0;
      const uniqueResult = result.filter(traveller => {
        const passport = traveller.passport?.trim() || ""; // Allow empty passports (don't filter them out)

        if (!passport) {
          return true;
        } // For non-empty passports, only keep the first occurrence


        if (seenPassports.has(passport)) {
          duplicatesRemoved++;
          return false;
        }

        seenPassports.add(passport);
        return true;
      });
      onDataParsed?.(uniqueResult, duplicatesRemoved, selectedFile);
      setFile(selectedFile);
    } catch (err) {
      if (err instanceof ExcelUpload_constants/* ExcelUploadError */.nY) {
        onError?.(err.code, err.missingFields); // Track excel error analytics

        analytics?.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: `excel | ${err.message}`
        });
      } else {
        const errorMessage = err instanceof Error ? err.message : "Failed to parse Excel file";
        setLocalError(errorMessage);
        onError?.(ExcelUpload_constants/* ExcelUploadErrorCode.UNKNOWN_ERROR */.rW.UNKNOWN_ERROR); // Track excel error analytics

        analytics?.trackTravDetailsEvents({
          actionType: "error_shown",
          payload: `excel | ${errorMessage}`
        });
      }
    } finally {
      setIsLocalLoading(false);
    }
  }, [validateFile, maxRows, onDataParsed, onError, validateHeaders, analytics]);
  const handleFileSelect = (0,react.useCallback)(e => {
    const selectedFile = e.target.files?.[0];

    if (selectedFile) {
      if (isExcelBypass) {
        uploadFileToServer(selectedFile);
      } else {
        parseExcelFile(selectedFile);
      }
    } // Reset input value to allow re-selecting same file


    if (inputRef.current) {
      inputRef.current.value = "";
    }
  }, [isExcelBypass, uploadFileToServer, parseExcelFile]);
  const handleRemoveFile = (0,react.useCallback)(() => {
    setFile(null);
    setLocalError("");
  }, []);
  const handleUploadClick = (0,react.useCallback)(() => {
    if (!disabled && !isLoading) {
      inputRef.current?.click();
    }
  }, [disabled, isLoading]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ExcelUploadWrapper, {
    className: className,
    "data-test-id": "ExcelUpload-ExcelUploadWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HiddenInput, {
      ref: inputRef,
      type: "file",
      accept: ".xlsx,.xls",
      onChange: handleFileSelect,
      disabled: disabled,
      "data-test-id": "ExcelUpload-HiddenInput"
    }), !file && /*#__PURE__*/(0,jsx_runtime.jsxs)(UploadRow, {
      "data-test-id": "ExcelUpload-UploadRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UploadButton, {
        type: "button",
        disabled: disabled,
        isLoading: isLoading,
        onClick: handleUploadClick,
        "data-test-id": "ExcelUpload-UploadButton",
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinner, {
            "data-test-id": "ExcelUpload-LoadingSpinner"
          }), isExcelBypass ? "Uploading..." : "Processing..."]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UploadIcon/* UploadIcon */.r, {
            "data-test-id": "ExcelUpload-UploadIcon"
          }), buttonText]
        })
      }), error && !hideError && /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorMessage, {
        "data-test-id": "ExcelUpload-ErrorMessage",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ErrorIcon/* ErrorIcon */.P, {
          "data-test-id": "ExcelUpload-ErrorIcon"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: error
        })]
      })]
    }), file && /*#__PURE__*/(0,jsx_runtime.jsxs)(FileInfo, {
      "data-test-id": "ExcelUpload-FileInfo",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FileDetails, {
        "data-test-id": "ExcelUpload-FileDetails",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExcelUpload_style_FileIcon, {
          "data-test-id": "ExcelUpload-FileIcon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FileIcon/* FileIcon */.a, {
            "data-test-id": "ExcelUpload-FileIconSvg"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FileName, {
          "data-test-id": "ExcelUpload-FileName",
          children: file.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FileSize, {
          "data-test-id": "ExcelUpload-FileSize",
          children: formatFileSize(file.size)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RemoveButton, {
        onClick: handleRemoveFile,
        title: "Remove file",
        "data-test-id": "ExcelUpload-RemoveButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {
          "data-test-id": "ExcelUpload-CloseIcon"
        })
      })]
    })]
  });
};

/* harmony default export */ const ExcelUpload_ExcelUpload = (ExcelUpload);

/***/ }),

/***/ 38418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ openCheckoutPage)
/* harmony export */ });
const openCheckoutPage = checkoutUrl => {
  try {
    if (!checkoutUrl) {
      /* istanbul ignore next */
      throw new Error(`Required parameters missing from native checkout bridge. checkoutUrl: ${checkoutUrl}`);
    }

    window?.open(checkoutUrl, "_self");
  } catch (error) {
    console?.log("PAYMENT REDIRECTION FAILED", error);
    /* istanbul ignore next */

    throw error;
  }
};

/***/ }),

/***/ 71870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ uploadTemplate)
/* harmony export */ });
/* harmony import */ var _tm_api_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91973);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44928);
/* harmony import */ var _checkout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38418);




const uploadTemplate = async (file, quoteId, itineraryId, isExcelBypass) => {
  const formData = new FormData();
  formData.append("file", file);
  const params = {
    quoteId: quoteId,
    itineraryId: itineraryId,
    isExcelBypass: isExcelBypass,
    lob: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.LOB.MYPARTNER
  };
  const urlParams = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_1__/* .setURLQueryParams */ .jT)(params);
  const response = await fetch(`${_tm_api_utils__WEBPACK_IMPORTED_MODULE_0__/* .API_ROUTE_V2_PREFIX_HTTPS */ .UO}/${_tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT}/${_tm_api_utils__WEBPACK_IMPORTED_MODULE_0__/* .API_ROUTES.UPLOAD_TEMPLATE */ .qf.UPLOAD_TEMPLATE}${urlParams ? `?${urlParams}` : ""}`, {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status: ${response.status}`);
  }

  const responseData = await response.json(); // Check if response indicates failure

  if (responseData.responseStatus !== "SUCCESS" || responseData.data?.status !== "SUCCESS") {
    throw new Error(responseData.message || "Upload failed");
  } // Handle checkout URL redirect if present


  if (responseData.data?.checkoutUrl) {
    (0,_checkout__WEBPACK_IMPORTED_MODULE_3__/* .openCheckoutPage */ .y)(responseData.data.checkoutUrl);
  }

  return responseData;
};

/***/ }),

/***/ 13864:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ExculsiveOffers_ExclusiveOffers)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/useBreakpoint/index.tsx
var useBreakpoint = __webpack_require__(53293);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/ExclusiveOffers.style.ts





const ExclusiveOffersStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__ExclusiveOffersStyle",
  componentId: "fapl6g-0"
})(["padding:16px 0;width:100%;background:", ";position:relative;z-index:1;overflow:hidden;display:flex;", "{width:64%;}@media ", "{background:", ";padding:", ";}"], p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MYBIZ ? `none` : Global/* theme.whiteText */.rS.whiteText, TextStyles_style/* H2TagStyle */.FI, utils/* deviceType.mobile */.vO.mobile, p => p.bgColor || Global/* theme.whiteText */.rS.whiteText, p => p.padding || "0 16px");
const OfferItemStyle = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ExclusiveOffersstyle__OfferItemStyle",
  componentId: "fapl6g-1"
})(["display:inline-block;background-color:", ";border-radius:8px;width:450px;height:220px;flex-shrink:0;overflow:hidden;@media ", "{width:286px;height:180px;border-radius:16px;", "}"], Global/* theme.whiteText */.rS.whiteText, utils/* deviceType.mobile */.vO.mobile, p => p.singleItem && `
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) / 1.5888888888888888);
    `);
const OffersWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__OffersWrap",
  componentId: "fapl6g-2"
})(["display:flex;align-items:center;gap:20px;overflow-x:auto;margin-left:-16px;padding-left:16px;margin-right:-16px;padding-right:16px;"]);
const SliderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderWrap",
  componentId: "fapl6g-3"
})(["display:flex;padding-left:7px;padding-top:7px;"]);
const SlidesBtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SlidesBtnWrap",
  componentId: "fapl6g-4"
})(["box-shadow:0px 1px 7px 0px #00000033;background-color:", ";border-radius:100px;padding:4px 14px;width:72px;height:28px;display:flex;align-items:center;justify-content:space-between;"], Global/* theme.whiteText */.rS.whiteText);
const SliderArrowLeft = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowLeft",
  componentId: "fapl6g-5"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(135deg);-webkit-transform:rotate(135deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderArrowRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ExclusiveOffersstyle__SliderArrowRight",
  componentId: "fapl6g-6"
})(["border:solid ", ";border-width:0 2px 2px 0;display:inline-block;padding:4px;transform:rotate(-45deg);-webkit-transform:rotate(-45deg);cursor:pointer;", ""], Global/* theme.blueText */.rS.blueText, p => p.disable && `opacity: 0.5;`);
const SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ExclusiveOffersstyle__SliderContainer",
  componentId: "fapl6g-7"
})(["overflow:hidden;width:100%;position:relative;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.tsx
var ImageTag = __webpack_require__(54990);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/OfferItem.tsx




const aspectRatio = (/* unused pure expression or super */ null && (286 / 180));

const OfferItem = ({
  cta,
  image_url,
  handleClickOfferItem,
  offerItemLength
}) => {
  const device = (0,useBreakpoint/* useBreakpoint */.G)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItemStyle, {
    onClick: handleClickOfferItem,
    href: cta.url,
    rel: "noreferrer",
    target: "_blank",
    singleItem: offerItemLength == 1 && device == "sm",
    "data-test-id": "OfferItem-OfferItemStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageTag/* default */.Z, {
      src: image_url,
      width: "100%",
      height: "100%",
      "data-test-id": "OfferItem-ImageTag"
    })
  });
};

/* harmony default export */ const ExculsiveOffers_OfferItem = (OfferItem);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/ExclusiveOffers.tsx













const analytics = (0,insurance/* getAnalytics */.I)();

const ExclusiveOffers = ({
  data,
  bgColor,
  padding
}) => {
  const device = (0,useBreakpoint/* useBreakpoint */.G)();
  const {
    0: currentSlide,
    1: setCurrentSlide
  } = (0,react.useState)(0);
  const {
    type
  } = (0,src/* usePlanType */.U)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();

  const handleNext = () => {
    if (currentSlide < data.items.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  (0,react.useEffect)(() => {
    data.items.forEach((item, index) => {
      const element = document.getElementById(`slide${index}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1
      });
      element && observer.observe(element);

      function obCallback(entries) {
        if (entries[0].isIntersecting) {
          analytics?.trackLandingEvents({
            actionType: `offer_banner${index + 1}_shown`
          }, "pageView", type);
          (0,XDMAnalytics.trackComponentView)({
            name: `offer_banner_${index + 1}_shown`,
            type: "offers"
          });
        }
      }
    });
  }, [data.items]);

  const handleClickOfferItem = index => {
    analytics?.trackLandingEvents({
      actionType: `offer_banner${index + 1}_clicked`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `offer_banner_${index + 1}_clicked`
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExclusiveOffersStyle, {
    bgColor: bgColor,
    padding: padding,
    "data-test-id": "ExclusiveOffers-ExclusiveOffersStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "ExclusiveOffers-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        margin: "0 0 60px",
        alignItems: "center",
        justifyContent: "space-between",
        "data-test-id": "ExclusiveOffers-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
          "data-test-id": "ExclusiveOffers-H2Tag",
          children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: data.title,
            "data-test-id": "ExclusiveOffers-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SlidesBtnWrap, {
          "data-test-id": "ExclusiveOffers-SlidesBtnWrap",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowLeft, {
            disable: currentSlide == 0,
            onClick: handlePrev,
            "data-test-id": "ExclusiveOffers-SliderArrowLeft"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderArrowRight, {
            disable: currentSlide == data.items.length - 1,
            onClick: handleNext,
            "data-test-id": "ExclusiveOffers-SliderArrowRight"
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        margin: "0 0 20px",
        "data-test-id": "ExclusiveOffers-H5Tag",
        children: data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.title,
          "data-test-id": "ExclusiveOffers-FormattedText"
        })
      }), device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersWrap, {
        "data-test-id": "ExclusiveOffers-OffersWrap",
        children: data.items && data.items.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: `slide${index}`,
            "data-test-id": `ExclusiveOffers-${index}`,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
              handleClickOfferItem: () => handleClickOfferItem(index),
              cta: item.cta,
              image_url: item.image_url,
              offerItemLength: data.items.length,
              "data-test-id": "ExclusiveOffers-OfferItem"
            })
          }, index);
        })
      }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderContainer, {
        "data-test-id": "ExclusiveOffers-SliderContainer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrap, {
          style: {
            transform: `translateX(-${currentSlide * 42}%)`,
            transition: "transform 0.5s ease-in-out"
          },
          "data-test-id": "ExclusiveOffers-SliderWrap",
          children: data.items && data.items.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: `slide${index}`,
              style: {
                marginRight: 20
              },
              "data-test-id": `ExclusiveOffers-${index}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExculsiveOffers_OfferItem, {
                handleClickOfferItem: () => handleClickOfferItem(index),
                cta: item.cta,
                image_url: item.image_url,
                "data-test-id": "ExclusiveOffers-OfferItem"
              })
            }, index);
          })
        })
      })]
    })
  });
};

/* harmony default export */ const ExculsiveOffers_ExclusiveOffers = (ExclusiveOffers);

/***/ }),

/***/ 55358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ FilterBottomComp_FilterBottomComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.style.ts

const FilterBottomCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterBottomCompStyle",
  componentId: "sc-1tibgkx-0"
})(["border-radius:6px;background:rgba(9,18,32,0.95);box-shadow:0px 0px 7px 0px rgba(0,0,0,0.43);position:fixed;bottom:16px;left:16px;right:16px;display:flex;align-items:center;z-index:3;overflow:hidden;max-height:68px;"]);
const FilterLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterLeftSection",
  componentId: "sc-1tibgkx-1"
})(["display:flex;gap:6px;overflow-x:scroll;padding:8px;div{border-radius:4px;background:#202e3c;padding:6px;text-align:center;flex:1;}"]);
const FilterRightSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterRightSection",
  componentId: "sc-1tibgkx-2"
})(["width:72px;height:68px;flex-shrink:0;background:#008cff;align-self:flex-end;display:flex;flex-direction:column;gap:6px;align-items:center;justify-content:center;margin-left:auto;position:relative;"]);
const FilterNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterBottomCompstyle__FilterNumber",
  componentId: "sc-1tibgkx-3"
})(["width:14px;height:14px;border-radius:100%;background:#fff;color:#008cff;text-align:center;font-size:10px;font-weight:700;line-height:14px;position:absolute;top:8px;left:43px;"]);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(81594);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.tsx







const FilterBottomComp = ({
  filtersList,
  handleFilterClick
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FilterBottomCompStyle, {
    "data-test-id": "FilterBottomComp-FilterBottomCompStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterLeftSection, {
      "data-test-id": "FilterBottomComp-FilterLeftSection",
      children: filtersList?.map((item, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          "data-test-id": "FilterBottomComp",
          children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            color: Global/* theme.whiteText */.rS.whiteText,
            fontWeight: "bold",
            fontSize: "xs",
            "data-test-id": "FilterBottomComp-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.title,
              "data-test-id": "FilterBottomComp-FormattedText"
            })
          }), item.planInfoMob && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
            color: Global/* theme.whiteText */.rS.whiteText,
            fontSize: "xs",
            "data-test-id": "FilterBottomComp-SpanTag",
            children: ["(", /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: item.planInfoMob,
              "data-test-id": "FilterBottomComp-FormattedText"
            }), ")"]
          })]
        }, `${index}`);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FilterRightSection, {
      onClick: handleFilterClick,
      "data-test-id": "FilterBottomComp-FilterRightSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "28px",
        height: "28px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/filter_Icon_eab36b44ec.svg",
        "data-test-id": "FilterBottomComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterNumber, {
        "data-test-id": "FilterBottomComp-FilterNumber",
        children: filtersList?.length
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        color: Global/* theme.whiteText */.rS.whiteText,
        "data-test-id": "FilterBottomComp-SpanTag",
        children: "Filter"
      })]
    })]
  });
};

/* harmony default export */ const FilterBottomComp_FilterBottomComp = (FilterBottomComp);

/***/ }),

/***/ 23618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ FilterPlans_FilterPlans)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.style.ts

const FilterPlansStyle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "FilterPlansstyle__FilterPlansStyle",
  componentId: "sc-1psxbt6-0"
})(["position:relative;"]);
const PlanTypeStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__PlanTypeStyle",
  componentId: "sc-1psxbt6-1"
})(["background:#ffffff;padding:16px 0px;"]);
const BtnWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__BtnWrap",
  componentId: "sc-1psxbt6-2"
})(["padding:16px 30px;background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:0px 0px 20px 20px;position:sticky;bottom:-20px;margin:auto -30px -20px;"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/PlanTypeComp.tsx







const PlanTypeComp = ({
  title,
  data,
  tagData,
  handleClickTab
}) => {
  const {
    0: planData,
    1: setPlanData
  } = (0,react.useState)(data);

  const planTypeHandler = id => {
    setPlanData(planData?.map(item => {
      if (id === item.id) {
        item.isSelected = !item.isSelected;
      }

      return item;
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanTypeStyle, {
    "data-test-id": "PlanTypeComp-PlanTypeStyle",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "md",
      fontWeight: "bold",
      color: Global/* theme.blackText */.rS.blackText,
      margin: "0 0 16px",
      "data-test-id": "PlanTypeComp-ParaTag",
      children: title
    }), tagData && /*#__PURE__*/(0,jsx_runtime.jsx)(components.Tags, {
      handleClickTab: handleClickTab,
      data: tagData,
      "data-test-id": "PlanTypeComp-Tags"
    }), data && data.map((item, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(components.CheckButton // inputIndex={item.id}
      , {
        inputId: item.id,
        margin: index != data.length - 1 ? "0 0 16px" : "",
        isChecked: item.isSelected,
        handleChange: () => planTypeHandler(item.id),
        "data-test-id": "PlanTypeComp-CheckButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          gap: "10px",
          justifyContent: "space-between",
          "data-test-id": "PlanTypeComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            gap: "0",
            flexDirection: "column",
            "data-test-id": "PlanTypeComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
              fontSize: "md",
              color: Global/* theme.blackText */.rS.blackText,
              margin: "0 0 4px",
              "data-test-id": "PlanTypeComp-ParaTag",
              children: item.planTitle
            }), item.planInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
              fontSize: "xs",
              color: Global/* theme.greyText7 */.rS.greyText7,
              "data-test-id": "PlanTypeComp-ParaTag",
              children: item.planInfo
            })]
          }), item.planIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "24px",
            height: "24px",
            src: item.planIcon,
            "data-test-id": "PlanTypeComp-ImageComponent"
          })]
        })
      });
    })]
  });
};

/* harmony default export */ const FilterPlans_PlanTypeComp = (PlanTypeComp);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.tsx







const FilterPlans = ({
  title,
  btnText,
  filterData,
  tagData,
  filterPlanHandleClick
}) => {
  const {
    0: tabIndex,
    1: setTabIndex
  } = (0,react.useState)(tagData);

  const handleTabIndex = id => {
    setTabIndex(tagData?.map(item => {
      if (id === item.id) {
        item.isSelected = true;
      } else item.isSelected = false;

      return item;
    }));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CommonModalDweb, {
    customTitle: title,
    handleClick: filterPlanHandleClick,
    "data-test-id": "FilterPlans-CommonModalDweb",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData?.popularData,
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData?.planType,
      title: "Plan Type",
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      tagData: tagData,
      title: "Sum Insured Per Traveller",
      handleClickTab: handleTabIndex,
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SectionDividers, {
      small: true,
      "data-test-id": "FilterPlans-SectionDividers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlans_PlanTypeComp, {
      data: filterData?.benefits,
      title: "Benefits Included",
      "data-test-id": "FilterPlans-PlanTypeComp"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BtnWrap, {
      "data-test-id": "FilterPlans-BtnWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
        customTitle: btnText,
        "data-test-id": "FilterPlans-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const FilterPlans_FilterPlans = (FilterPlans);

/***/ }),

/***/ 88025:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ FlexCompStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);


const renderAlign = alignItems => {
  switch (alignItems) {
    case "center":
      return `align-items: center;`;

    case "baseline":
      return `align-items: baseline;`;

    case "flex-start":
      return `align-items:flex-start;`;

    case "flex-end":
      return `align-items:flex-end;`;

    default:
      return `align-items:center;`;
  }
};

const renderAlignSelf = alignSelf => {
  switch (alignSelf) {
    case "center":
      return `align-self: center;`;

    case "baseline":
      return `align-self: baseline;`;

    case "flex-start":
      return `align-self:flex-start;`;

    case "flex-end":
      return `align-self:flex-end;`;

    default:
      return `align-self:unset;`;
  }
};

const renderJustify = justifyContent => {
  switch (justifyContent) {
    case "center":
      return `justify-content:center;`;

    case "flex-start":
      return `justify-content:flex-start;`;

    case "end":
      return `justify-content:end;`;

    case "space-between":
      return `justify-content:space-between;`;

    case "inherit":
      return `justify-content:inherit;`;

    case "right":
      return `justify-content:right;`;

    default:
      return `justify-content:center;`;
  }
};

const renderDir = flexDirection => {
  switch (flexDirection) {
    case "row":
      return `flex-direction:row;`;

    case "column":
      return `flex-direction:column;`;

    case "row-reverse":
      return `flex-direction:row-reverse;`;

    case "column-reverse":
      return `flex-direction:column-reverse;`;

    default:
      return `flex-direction:row;`;
  }
};

const FlexCompStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FlexCompstyle__FlexCompStyle",
  componentId: "sc-11q208e-0"
})(["display:flex;position:relative;cursor:", ";", " ", " ", " ", " gap:", ";flex:", ";flex-shrink:", ";margin:", ";padding:", ";border-bottom:", ";border-top:", ";background:", ";border-radius:", ";height:", ";width:", ";box-shadow:", ";pointer-events:auto;flex-wrap:", ";"], props => props.isCursorPointer ? "pointer" : "default", p => p.alignItems && `
    ${renderAlign(p.alignItems)}
  `, p => p.alignSelf && `
    ${renderAlignSelf(p.alignSelf)}
  `, p => p.justifyContent && `
    ${renderJustify(p.justifyContent)}
  `, p => p.flexDirection && `
    ${renderDir(p.flexDirection)}
  `, p => p.gap ? p.gap : "0", p => p.flex ? p.flex : "unset", p => p.flexShrink ? p.flexShrink : "unset", p => p.margin ? p.margin : "unset", p => p.padding ? p.padding : "0", p => p.borderBottom ? p.borderBottom : "none", p => p.borderTop ? p.borderTop : "none", p => p.bgColor ? p.bgColor : "transparent", p => p.borderRadius ? p.borderRadius : "0", p => p.height ? p.height : "unset", p => p.width ? p.width : "unset", p => p.boxShadow ? p.boxShadow : "none", p => p.flexWrap ? p.flexWrap : "");

/***/ }),

/***/ 636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _FlexComp_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88025);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);




const FlexComp = ({
  children,
  flexDirection,
  // 2
  alignItems,
  // 2
  justifyContent,
  // 4
  gap,
  margin,
  borderBottom,
  borderTop,
  padding,
  flex,
  //
  bgColor,
  borderRadius,
  height,
  flexShrink,
  handleClick,
  boxShadow,
  width,
  isCursorPointer = false,
  flexWrap,
  alignSelf
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l, {
    flexDirection: flexDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    isCursorPointer: isCursorPointer ? true : handleClick ? true : false,
    gap: gap,
    margin: margin,
    borderBottom: borderBottom,
    borderTop: borderTop,
    padding: padding,
    flex: flex,
    bgColor: bgColor,
    borderRadius: borderRadius,
    height: height,
    flexShrink: flexShrink,
    width: width,
    boxShadow: boxShadow,
    onClick: handleClick,
    flexWrap: flexWrap,
    alignSelf: alignSelf,
    "data-test-id": "FlexComp-FlexCompStyle",
    children: children
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FlexComp);

/***/ }),

/***/ 36907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ FooterSectionComp_FooterSectionComp)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.tsx
var ToolTipComp = __webpack_require__(94510);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FooterSectionComp/FooterSectionComp.style.ts

const FooterSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterSectionCompstyle__FooterSectionContainer",
  componentId: "oehg2s-0"
})(["border-bottom-left-radius:16px;border-bottom-right-radius:16px;"]);
const FooterBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterSectionCompstyle__FooterBorder",
  componentId: "oehg2s-1"
})(["background:linear-gradient( to right,", " );height:2px;"], props => props.borderGradient?.join(", "));
const FooterDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FooterSectionCompstyle__FooterDescription",
  componentId: "oehg2s-2"
})(["font-size:14px;font-weight:900;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/FooterSectionComp/FooterSectionComp.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const FooterSectionComp = ({
  icon,
  description,
  background,
  border,
  tooltip
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const [isHovered, setIsHovered] = react.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const backgroundStyle = {
    background: `linear-gradient(to right, ${background?.startColor}, ${background?.endColor})`
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterSectionContainer, {
    style: _objectSpread({}, backgroundStyle),
    "data-test-id": "FooterSectionComp-FooterSectionContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FooterBorder, {
      borderGradient: border?.gradient,
      "data-test-id": "FooterSectionComp-FooterBorder"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      padding: "12px 20px",
      gap: "8px",
      alignItems: "center",
      "data-test-id": "FooterSectionComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
        width: "16px",
        height: "16px",
        alt: "icon",
        src: icon,
        "data-test-id": "FooterSectionComp-ImageComponent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterDescription, {
        "data-test-id": "FooterSectionComp-FooterDescription",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: description,
          "data-test-id": "FooterSectionComp-FormattedText"
        })
      }), tooltip?.icon && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
          width: "16px",
          height: "16px",
          alt: "icon",
          src: tooltip?.icon,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          "data-test-id": "FooterSectionComp-ImageComponent"
        }), isHovered &&
        /*#__PURE__*/
        //TODO: Check Moving tooltip to portal
        (0,jsx_runtime.jsx)(ToolTipComp/* default */.Z, {
          handleMouseEnter: handleMouseEnter,
          handleMouseLeave: handleMouseLeave,
          left: device === "lg" ? "43%" : "134px",
          top: device === "lg" ? "-15px" : "-80px",
          toolTipArrow: device === "lg" ? "left" : "bottom",
          width: "247px",
          backgroundColor: "black",
          "data-test-id": "FooterSectionComp-ToolTipComp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: tooltip.description,
            "data-test-id": "FooterSectionComp-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ const FooterSectionComp_FooterSectionComp = (FooterSectionComp);

/***/ }),

/***/ 17871:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "i": () => (/* binding */ getPlainText)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87109);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* Every text node can be of either of the three formats - 
1. string - "Hello"
2. text obj with value and styles - 
   text: {
    value: "Travel Assistance",
    styles: {
      color: "#000000",
      fontFamily: "fontSansBold",
    },
  }
3. Array of text objs with value and styles - 
   text: [
    {
      value: "Travel Assistance",
      styles: {
        color: "#000000",
        fontFamily: "fontSansBold",
      },
    },
  ]
*/




const ListItemText = ({
  text,
  style
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("p", {
    style: {
      flexDirection: "row"
    },
    "data-test-id": "ListItemText",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      style: style,
      children: "\u2022 "
    }), text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      style: style,
      children: text
    })]
  });
};

const getPlainText = data => {
  if (!data) {
    return "";
  } else if (typeof data === "string") {
    return data;
  } else if (data?.text) {
    const {
      text
    } = data;

    if (Array.isArray(text)) {
      return text.map(node => node.value).join("");
    } else if (typeof text === "object") {
      return text?.value || "";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

const FormattedText = ({
  value,
  baseStyle
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();
  let isList = false;

  if (!value) {
    return null;
  }

  let returnValue = null;

  if (typeof value === "string") {
    returnValue = value;
  } else if (value?.text) {
    const {
      text,
      displayType
    } = value;

    if (displayType === "UNORDERED_LIST") {
      isList = true;
    }

    if (Array.isArray(text)) {
      returnValue = text.map((node, index) => {
        const mobileStyle = node.styles?.mobile;

        const combinedStyles = _objectSpread(_objectSpread({}, node?.styles), device === "sm" && _objectSpread({}, mobileStyle));

        const textValue = node?.value;
        return node.value ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: isList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ListItemText, {
            text: textValue ? textValue : "",
            style: node?.styles,
            "data-test-id": "FormattedText-ListItemText"
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            style: combinedStyles,
            children: node.value
          }, index)
        }, index) : null;
      });
    } else if (typeof text === "object") {
      const mobileStyle = text?.styles?.mobile;

      const combinedStyles = _objectSpread(_objectSpread({}, text?.styles), device === "sm" && _objectSpread({}, mobileStyle));

      returnValue = text?.value ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        style: combinedStyles,
        "data-test-id": "FormattedText",
        children: text.value
      }) : null;
    } else {
      returnValue = text;
    }
  }

  return value?.html ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
    dangerouslySetInnerHTML: {
      __html: value.html
    },
    style: baseStyle ?? {}
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
    style: baseStyle ?? {},
    children: returnValue
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormattedText);

/***/ }),

/***/ 22274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ GIInsuranceHeader)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _growth_dweb_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31956);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87109);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48359);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const GiDwebAuth = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.bind(__webpack_require__, 94410)).then(p => p.default), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(94410)]
  }
});
const GiMwebAuth = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(() => Promise.all(/* import() */[__webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.bind(__webpack_require__, 40793)).then(p => p.MwebAuth), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(40793)]
  }
});
let isCalled = false;
function GIInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  forceLogin = false,
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  showPwaHeaderBackButton = true,
  onLoginSuccess
}) {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointV2 */ .bU)();

  const headerPropsWithDefaults = _objectSpread({
    lobName: "insurance",
    sticky: true,
    shouldShowCloseButton: true,
    navOrigin: "https://www.goibibo.com"
  }, headerProps);

  let authComponent = null;
  const {
    0: isAuthComponentVisible,
    1: setIsAuthComponentVisible
  } = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(forceLogin);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    setIsAuthComponentVisible(forceLogin);
  }, [forceLogin]);

  if (isAuthComponentVisible) {
    authComponent = device === "lg" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(GiDwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: () => console.log("Closed"),
      lobName: "insurance",
      onLoginSuccess: () => {
        if (onLoginSuccess) {
          if (!isCalled) {
            isCalled = true;
            onLoginSuccess();
          }
        } else if ((0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCookieByName */ .A7)("next_page_req")) {
          window.location.href = `https://tripmoney.goibibo.com/insurance/next-page`;
        } else {
          next_router__WEBPACK_IMPORTED_MODULE_6___default().reload();
        }
      },
      configData: undefined,
      "data-test-id": "GiDwebAuth"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(GiMwebAuth, {
      prefillMobileNumber: undefined,
      showCloseButton: false,
      onClose: () => console.log("Closed"),
      lobName: "",
      onLoginSuccess: () => {
        if (onLoginSuccess) {
          if (!isCalled) {
            isCalled = true;
            onLoginSuccess();
          }
        } else if ((0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCookieByName */ .A7)("next_page_req")) {
          window.location.href = `https://tripmoney.goibibo.com/insurance/next-page`;
        } else {
          setIsAuthComponentVisible(false);
          setTimeout(() => {
            next_router__WEBPACK_IMPORTED_MODULE_6___default().reload();
          }, 100);
        }
      },
      showAuth: true,
      "data-test-id": "GiMwebAuth"
    });
    authComponent = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.7)"
      },
      children: authComponent
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [authComponent, device === "lg" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_growth_dweb_header__WEBPACK_IMPORTED_MODULE_1__/* .Header */ .h4, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      "data-test-id": "Header"
    })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(___WEBPACK_IMPORTED_MODULE_8__.LandingHeaderMobile, {
      headerTitle: mobileTitle,
      myOrders: myOrders,
      goToMyOrders: goToMyOrders,
      displayWhiteHeader: displayWhiteHeader,
      partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_3__.PARTNER.GI,
      insuranceHeader: true,
      showPwaHeaderBackButton: showPwaHeaderBackButton,
      "data-test-id": "LandingHeaderMobile"
    })]
  });
}

/***/ }),

/***/ 61891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ GreatChoiceStyle)
/* harmony export */ });
/* unused harmony export ChoiceText */
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);


const GreatChoiceStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "GreatChoicestyle__GreatChoiceStyle",
  componentId: "sc-1njux19-0"
})(["", ";", ";", ";"], props => props.background && `background: ${props.background}`, props => props.radius && `border-radius: ${props.radius}`, props => props.padding && `padding: ${props.padding}`);
const ChoiceText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "GreatChoicestyle__ChoiceText",
  componentId: "sc-1njux19-1"
})(["position:relative;margin-top:16px;color:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText);

/***/ }),

/***/ 56230:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _GreatChoice_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61891);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const GreatChoice = ({
  title,
  info,
  icon,
  background,
  padding,
  radius
}) => {
  const data = {
    text: [{
      value: "Valid for Travel. Over "
    }, {
      value: "15k",
      styles: {
        fontWeight: "bold"
      }
    }, {
      value: " Travellers insured in the last 3 months."
    }]
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_GreatChoice_style__WEBPACK_IMPORTED_MODULE_2__/* .GreatChoiceStyle */ .D, {
    background: background,
    padding: padding,
    radius: radius,
    "data-test-id": "GreatChoice-GreatChoiceStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
      margin: "0 0 8px",
      alignItems: "center",
      gap: "12px",
      "data-test-id": "GreatChoice-FlexComp",
      children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ImageComponent, {
        src: icon,
        height: "32",
        width: "32",
        "data-test-id": "GreatChoice-ImageComponent"
      }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.H5Tag, {
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greenText */ .rS.greenText,
        "data-test-id": "GreatChoice-H5Tag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
          value: title,
          "data-test-id": "GreatChoice-FormattedText"
        })
      })]
    }), (info || data) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText,
      "data-test-id": "GreatChoice-SpanTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
        value: info ? info : data,
        "data-test-id": "GreatChoice-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GreatChoice);

/***/ }),

/***/ 85443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _GreatChoice_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61891);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const GreatChoiceShimmer = ({
  title,
  info
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_GreatChoice_style__WEBPACK_IMPORTED_MODULE_2__/* .GreatChoiceStyle */ .D, {
    "data-test-id": "GreatChoiceShimmer-GreatChoiceStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.Shimmer, {
      width: "283px",
      height: "32px",
      margin: "0 0 8px",
      "data-test-id": "GreatChoiceShimmer-Shimmer"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.Shimmer, {
      width: "100%",
      height: "22px",
      "data-test-id": "GreatChoiceShimmer-Shimmer"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GreatChoiceShimmer);

/***/ }),

/***/ 9309:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17871);
/* harmony import */ var _TextStyles_H4Tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14485);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);




const HeaderTitleComp = data => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_TextStyles_H4Tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    "data-test-id": "HeaderTitleComp-H4Tag",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      value: data.title,
      baseStyle: {
        color: "white"
      },
      "data-test-id": "HeaderTitleComp-FormattedText"
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HeaderTitleComp);

/***/ }),

/***/ 48608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ ImageComponent)
/* harmony export */ });
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84576);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



const ImageComponent = ({
  src,
  width,
  height,
  alt = "",
  loading = "lazy",
  className = "",
  id = "",
  cdnUrlWidths = [],
  sizes = "",
  margin,
  onMouseEnter,
  onMouseLeave
}) => {
  const imgStyle = margin ? {
    margin
  } : {};

  if (!src || !width || !height) {
    return null;
  }

  if (src.endsWith && src.endsWith(".svg")) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      style: imgStyle,
      className: className,
      id: id,
      width: width,
      height: height,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      "data-test-id": "ImageComponent"
    });
  }

  const srcsetUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_0__/* .generateSourceSetImageUrl */ .sI)(cdnUrlWidths, src, parseInt(width));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
    "data-test-id": "ImageComponent-picture",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
      "data-testid": "testID",
      srcSet: srcsetUrl,
      sizes: sizes ? sizes : width,
      "data-test-id": "ImageComponent-source"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: src,
      loading: loading,
      alt: alt,
      className: className,
      id: id,
      width: width,
      height: height,
      style: imgStyle,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })]
  });
};

/***/ }),

/***/ 61770:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ ImageTagStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const ImageTagStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "ImageTagstyle__ImageTagStyle",
  componentId: "sc-16jb4o3-0"
})(["display:inline-block;margin:", ";width:", ";", " flex-shrink:0;"], props => props.margin, props => props.width, props => props.showCursorPointer && ` cursor: pointer;`);

/***/ }),

/***/ 54990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _ImageTag_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61770);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);



const ImageTag = ({
  src,
  width,
  alt = "image-tag",
  margin,
  height,
  showCursorPointer = false
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageTag_style__WEBPACK_IMPORTED_MODULE_0__/* .ImageTagStyle */ .L, {
    src: src,
    width: width,
    margin: margin,
    height: height,
    showCursorPointer: showCursorPointer,
    alt: alt,
    "data-test-id": "ImageTag-ImageTagStyle"
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ImageTag);

/***/ }),

/***/ 76124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": () => (/* binding */ BulletList),
/* harmony export */   "ly": () => (/* binding */ BulletText),
/* harmony export */   "nU": () => (/* binding */ BulletIcon),
/* harmony export */   "uh": () => (/* binding */ InfoModalBody),
/* harmony export */   "vo": () => (/* binding */ BulletItem)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const InfoModalBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InfoModalstyle__InfoModalBody",
  componentId: "h45gtq-0"
})(["padding:16px 30px 30px;"]);
const BulletList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "InfoModalstyle__BulletList",
  componentId: "h45gtq-1"
})(["list-style:none;margin:0 0 30px 0;padding:0;display:flex;flex-direction:column;gap:8px;"]);
const BulletItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "InfoModalstyle__BulletItem",
  componentId: "h45gtq-2"
})(["display:flex;align-items:flex-start;gap:12px;"]);
const BulletIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InfoModalstyle__BulletIcon",
  componentId: "h45gtq-3"
})(["width:6px;height:6px;border-radius:50%;background-color:#000000;flex-shrink:0;margin-top:8px;"]);
const BulletText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "InfoModalstyle__BulletText",
  componentId: "h45gtq-4"
})(["font-size:16px;line-height:1.5;color:#000000;flex:1;"]);

/***/ }),

/***/ 68634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export InfoModal */
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17871);
/* harmony import */ var _ImageComponent_ImageComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48608);
/* harmony import */ var _LandingButton_LandingButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99660);
/* harmony import */ var _ModalWrapper_ModalWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38949);
/* harmony import */ var _InfoModal_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76124);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52322);









const InfoModal = ({
  data,
  isOpen,
  onClose,
  onCTAClick
}) => {
  if (!data) return null;
  const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__/* .getAnalytics */ .I)();
  const {
    heading,
    list,
    ctaText
  } = data;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    analytics?.trackCommonLandingEvents({
      actionType: "annual_multi_trip_bottomsheet_seen"
    });
  }, []);
  const ctaTextInfo = typeof ctaText?.title?.text === "object" && !Array.isArray(ctaText?.title?.text) ? ctaText?.title?.text?.value : "EXPLORE PLANS";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_ModalWrapper_ModalWrapper__WEBPACK_IMPORTED_MODULE_5__/* .ModalWrapper */ .A, {
    isOpen: isOpen,
    onClose: onClose,
    "data-test-id": "InfoModal-ModalWrapper",
    children: [heading?.deskImg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ImageComponent_ImageComponent__WEBPACK_IMPORTED_MODULE_3__/* .ImageComponent */ .c, {
      src: heading.deskImg,
      width: "500px",
      height: "auto",
      alt: "Travel Safety",
      "data-test-id": "InfoModal-ImageComponent"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_InfoModal_style__WEBPACK_IMPORTED_MODULE_6__/* .InfoModalBody */ .uh, {
      "data-test-id": "InfoModal-InfoModalBody",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_InfoModal_style__WEBPACK_IMPORTED_MODULE_6__/* .BulletList */ .DY, {
        "data-test-id": "InfoModal-BulletList",
        children: list.map((item, index) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_InfoModal_style__WEBPACK_IMPORTED_MODULE_6__/* .BulletItem */ .vo, {
          "data-test-id": `InfoModal-BulletItem-${index}`,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_InfoModal_style__WEBPACK_IMPORTED_MODULE_6__/* .BulletIcon */ .nU, {
            "data-test-id": "InfoModal-BulletIcon"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_InfoModal_style__WEBPACK_IMPORTED_MODULE_6__/* .BulletText */ .ly, {
            "data-test-id": "InfoModal-BulletText",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              value: item.title,
              "data-test-id": "InfoModal-FormattedText"
            })
          })]
        }, index))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_LandingButton_LandingButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        customTitle: ctaTextInfo,
        onClick: () => {
          analytics?.trackCommonLandingEvents({
            actionType: "annual_multi_trip_bottomsheet_primary_cta_clicked"
          });
          onCTAClick?.();
        },
        customWidth: "100%",
        "data-test-id": "InfoModal-LandingButton"
      })]
    })]
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InfoModal);

/***/ })

}]);